/// <reference path="../Constants.js" />
/// <reference path="../Helpers.js" />

window.ChartSetupUI = function () {

    $(document).ready(function () {
        $("#btnResetChartStyleControls").bind("click", function (evt) {
            Storyboard.HighchartsWrapper.resetChartStyleControls();
            evt.preventDefault();
        });
        $('#chartstyle_xAxis_lineWidth').bind('change', function (evt) {
            window.lineWidthSelected('#chartstyle_xAxis_lineWidth', 'x');
        });
        $('#chartstyle_yAxis_lineWidth').bind('change', function (evt) {
            window.lineWidthSelected('#chartstyle_yAxis_lineWidth', 'y');
        });
        $('#chartstyle_series_borderWidth').bind('change', function (evt) {
            window.lineWidthSelected('#chartstyle_series_borderWidth', null);
        });
        $('#chartstyle_xAxis_labels_style_width').bind('change', function () {
            $('#chartStyling_fixedWidthWrapper').toggle($(this).val() == 'Fixed');
        });
        $("#chbUseTwoColorLogic").bind("change", function () {
            if ($(this).attr("checked")) {
                $(".seriesLabelsTwoColor").show();
                $(".seriesLabelsOneColor").hide();
            } else {
                $(".seriesLabelsTwoColor").hide();
                $(".seriesLabelsOneColor").show();
            }
        });
        $("#chkAutoSeriesPointWidth").bind("change", function () {
            if ($(this).attr("checked")) {
                $("#chartstyle_series_pointWidth").attr("disabled", "disabled");
            } else {
                $("#chartstyle_series_pointWidth").removeAttr("disabled");
            }
        });
        $("#chartstyle_xAxis_labels_rotation").bind("change", function () {
            if ($(this).val() == "0") { // horizontal
                HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#chartstyle_xAxis_labels_style_width'), '[value="Fixed"]')); 
                $("#chartstyle_xAxis_labels_style_width option[value='True']").text("Auto wrap text");
                $("#chartstyle_xAxis_labels_style_width option[value='False']").text("No wrapping");
            } else {
                if ($("#chartstyle_xAxis_labels_style_width").val() == 'Fixed') { // select Auto instead
                    $("#chartstyle_xAxis_labels_style_width").val("True");
                    $("#chartstyle_xAxis_labels_style_width").change();
                }
                HTMLHelpers.optionToComment($("#chartstyle_xAxis_labels_style_width option[value='Fixed']"));
                $("#chartstyle_xAxis_labels_style_width option[value='True']").text("Auto");
                $("#chartstyle_xAxis_labels_style_width option[value='False']").text("Crop");
            }
        });

        $("#chartstyle_series_dataLabels_align").change(function () {
            ChartSetupUI.showHideTwoColorControls();
            ChartSetupUI.showHideDataLabelPadding();
        });

        $("#chartstyle_series_dataLabels_distance").bind("change", function () {
            ChartSetupUI.showHideTwoColorControls();
        });

        var seriesType = $('#ddlSeriesType > option:selected').val();
        if (seriesType == '2' || seriesType == '3' || seriesType == '18') {
            $('#divColumnBarStyles').show();
        } else {
            $('#divColumnBarStyles').hide();
        }

        $('#chbTrimLowBaseByMain').bind('change', ChartSetupUI.showHideSubseriesLowBase);
        $('#chbTrimLowResultByMain').bind('change', ChartSetupUI.showHideSubseriesLowResult);
        $('#chbWarnLowBaseByMain').bind('change', ChartSetupUI.showHideSubseriesWarnLowBase);

        $('.ChartStyleDashStyle').each(function () {
            var dashBox = $(this);
            dashBox.click(function (evt) {
                evt.stopPropagation();
                if (dashBox.hasClass('ChartStyleDashStyleActive')) {
                    Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
                    return false;
                }
                Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
                $('.DUI-ColorPicker').parent().remove(); // Hide colorpickers active gui
                $('body').children('.ChartStyleDashStyleList').remove();
                var listbox = dashBox.children('.ChartStyleDashStyleList').clone();
                listbox.attr('data-value', dashBox.attr('id'));
                $('body').append(listbox);
                var listitems = listbox.children('div[data-value]');
                dashBox.addClass('ChartStyleDashStyleActive');

                listbox
                    .css({
                        top: dashBox.offset().top + dashBox.height() + 'px',
                        left: dashBox.offset().left + 'px',
                        width: (dashBox.outerWidth() - 2) + 'px'
                    })
                    .mouseenter(function (evt) {
                        $(this).children().css('background-color', '#fff');
                    });
                listbox.toggle();

                listitems
                    .each(function (index, elem) {
                        if ($(elem).attr('data-value') == dashBox.children('.ChartStyleDashStyleValue').attr('data-value'))
                            $(elem).css('background-color', '#f4f4f4');

                        $(elem).hover(function (evt) {
                            $(this).css('background-color', '#f4f4f4');
                        }, function (evt) {
                            $(this).css('background-color', '#ffffff');
                        })
                            .click(function (evt2) {
                                evt2.stopPropagation();
                                var dashBox2 = $(evt2.currentTarget).parent().attr('data-value');
                                window.selectDashStyle(evt2, '#' + dashBox2);
                                Storyboard.GuiEvents.hideAllMenusAndPanels(evt2);
                            });
                    });
            });
            dashBox.children('.ChartStyleDashStyleList').hide();
            dashBox.children('.ChartStyleDashStyleList').children('div[data-value]').each(function (index, elem) {
                $(elem).children('span').text('');
                $(elem).children('span').attr('title', $(this).attr("data-value"));
                $(elem).children('span').css('background-image', "url('images/chart_descriptions/" + $(this).attr("data-value") + ".png')");
                if ($(elem).attr('data-value') == dashBox.children('.ChartStyleDashStyleValue').attr('data-value'))
                    $(elem).css('background-color', '#f4f4f4');
            });
        });
    });

    var autoPreviewControls = [
        '#ddlColorLogic',
        '#seriesColorCategory',
        '#seriesColorPreview',
        '#dynamicColorPreview',
        '#cbShowValues',
        '#txtNoofDecimals',
        '#ddlShowBase',
        '#ddlBasePosition',
        '#txtMinScale',
        '#txtMaxScale',
        '#cbShowQuestionTexts',
        '#cbShowAnswerTexts',
        '#cbShowFilterTexts',
        '#cbShowTimeIntervalTexts',
        '#chbShowFilterInTitle',
        '#ddlFontSizeDataLabel',
        '#ddlFontSizeSerieAxis',
        '#ddlFontSizeLegend',
        '#ddlFontSizeInformation',
        '#chartstyle_xAxis_labels_rotation'
    ];

    function showUseDynamicWeightCheckbox($filterBox) {
        $filterBox.find('#chkUseDynamicWeighting').show();
        $filterBox.find('#lblUseDynamicWeighting').show();
    }

    function hideUseDynamicWeightCheckbox($filterBox) {
        $filterBox.find('#chkUseDynamicWeighting').hide();
        $filterBox.find('#lblUseDynamicWeighting').hide();
    }

    function enableUseDynamicWeightCheckbox($filterBox) {
        $filterBox.find('#chkUseDynamicWeighting').removeAttr('disabled');
    }

    function disableUseDynamicWeightCheckbox($filterBox) {
        $filterBox.find('#chkUseDynamicWeighting').attr('disabled', 'disabled');
    }

    function uncheckUseDynamicWeightCheckbox($filterBox) {
        $filterBox.find('#chkUseDynamicWeighting').removeAttr('checked');
    }

    function removeDynamicWeightingSupport($filterBox) {
        hideUseDynamicWeightCheckbox($filterBox);
        disableUseDynamicWeightCheckbox($filterBox);
        uncheckUseDynamicWeightCheckbox($filterBox);
    }

    function getAllWeighedFilters(){
        var allWeightedFilters = $('.settingItemBlock input#hidIsConnectedToWeights[value="true"]')
            .map(function (idx, hid) { return $(hid).closest('.settingItemBlock') });

        return allWeightedFilters;
    }

    function getWeightedCompareFilters($filtersBoxesConnectedToWeights){
        return $filtersBoxesConnectedToWeights.filter(function(idx, $filterBox){
            return $filterBox.find("#chkCompare:checked").length === 1;
        })
    }

    function getRegularWeightedFilters($filtersBoxesConnectedToWeights){
        return $filtersBoxesConnectedToWeights.filter(function(idx, $filterBox){
            return $filterBox.find("#chkCompare:checked").length === 0;
        })
    }

    function removeWeightCheckboxFromRegularFilters($regularWeightedFilters){
        $regularWeightedFilters.each(function(idx, $filterBox){
            removeDynamicWeightingSupport($filterBox);
        });
    }

    function updateWeightCheckboxesForNestedCompareFilters($compareFilterBoxes) {
        var $useWeightCompareFilters = $compareFilterBoxes.filter(function(idx, $filterBox){
            return $filterBox.find("#chkUseDynamicWeighting:checked").length === 1;
        });

        if($useWeightCompareFilters.length === 0) {
            $compareFilterBoxes.each(function (idx, $filterBox) {
                enableUseDynamicWeightCheckbox($filterBox);
            });
        }

        if($useWeightCompareFilters.length > 1) {
            $compareFilterBoxes.each(function (idx, $filterBox) {
                enableUseDynamicWeightCheckbox($filterBox);
                uncheckUseDynamicWeightCheckbox($filterBox);
            });
        }

        if($useWeightCompareFilters.length == 1) {
            $compareFilterBoxes.each(function (idx, $filterBox) {
                if($filterBox.find("#chkUseDynamicWeighting:checked").length === 1)
                    enableUseDynamicWeightCheckbox($filterBox);
                else
                    disableUseDynamicWeightCheckbox($filterBox);
            });
        }

        $compareFilterBoxes.each(function (idx, $filterBox) { showUseDynamicWeightCheckbox($filterBox); });
    }

    function updateWeightCheckboxesForNonNestedCompareFilters($compareFilterBoxes) {
        $compareFilterBoxes.each(function (idx, $filterBox) {
            showUseDynamicWeightCheckbox($filterBox);
            enableUseDynamicWeightCheckbox($filterBox);
        });
    }

    return {
        maketabs: function () {
            $("#tabholder").tabs("destroy");
            $('#panels > div').removeClass('ui-corner-all');
            $('#panels h3').unbind('click');

            $("div#panels > h3").hide();
            $("ul.tabs").show();

            $('#tabholder').removeClass('ui-widget');
            $("#tabholder").tabs({
                select: function (evt, ui) {
                    var currentTab = $('#tabholder .ui-state-active > a').get(0);
                    var itemType = ChartSetupDataBinding.GetBoundContentType();
                    var dataGroup;
                    var mainDg;
                    if (currentTab.hash == '#chartEvents') {
                        dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
                        mainDg = Storyboard.DataGroupLogic.getMainDataGroupForLayoutElementItem(dataGroup.guid);
                        mainDg.userEvents = Storyboard.LayoutDesigner.UserEvents.getEventsOptions(
                            itemType == Storyboard.Constants.itemTypes.CHART ? $('#divChart') : $('#divTable'));
                    } else if (ui.tab.hash == '#chartEvents' && $('#chartEvents #layoutElementUserEvents').length == 0) {
                        dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
                        mainDg = Storyboard.DataGroupLogic.getMainDataGroupForLayoutElementItem(dataGroup.guid);
                        Storyboard.LayoutDesigner.UserEvents.setChartEventsTabUI(mainDg.userEvents,
                            itemType == Storyboard.Constants.itemTypes.CHART ? $('#divChart')[0] : $('#divTable')[0]);
                    }
                    Storyboard.GuiEvents.hideAllMenusAndPanels(evt);
                },
                show: function (evt, ui) {
                    if (ui.tab.hash === "#filterSelection") {
                        $('#filterBox .filterboxHeaderWrapper td').equalHeights();
                    }
                }
            });
        },
        showall: function () {
            $("#tabholder").tabs("destroy");
            $('#tabholder').addClass('ui-widget');
            $("#panels").accordion("destroy");
            $('#panels h3').unbind('click');
            $(".tabs").hide();
            $("div#panels > h3").show();
            $('#panels h3').next().show();
            $('#panels > div').addClass('ui-widget-content ui-tabs-panel ui-corner-all');

        },
        shiftItems: function (direction, elementId) {
            var selecteditems;
            if (direction === "up")
                selecteditems = $('#' + elementId).val();
            else
                selecteditems = $.makeArray($('#' + elementId).val()).reverse();

            $(selecteditems).each(function () {
                var currentItem = $("#" + elementId + " option[value='" + this + "']");
                var previousItem = currentItem.prev();
                var nextItem = currentItem.next();


                if (direction === "up")
                    previousItem.before(currentItem);
                else
                    nextItem.after(currentItem);
            });

            ChartSetupDataBinding.UpdateGroupings();

            $(selecteditems).each(function () {
                var currentItem = $('#' + elementId + ' option[value="' + this + '"]');
                currentItem.attr('selected', true);
            });

        },
        changeOrder: function (direction, elementid) {
            var selItems = $('#' + elementid).val(), groupItem;
            var allGroupings = ChartSetupDataBinding.GetBoundDataGroup().groupedItems;

            for (var i = 0; i < selItems.length; i++) {
                if (selItems.hasOwnProperty(i)) {
                    groupItem = ChartSetupDataBinding.GetGroupingByValue(selItems[i]);
                    var index = $.inArray(groupItem, allGroupings);
                    var currElementInPos;

                    /* just shift the item up or down the array depending on which array was selected */
                    if (direction === 'down' && index + selItems.length <= (allGroupings.length - 1)) {
                        currElementInPos = allGroupings[index + i + 1];
                        allGroupings[index + i + 1] = groupItem;
                        allGroupings[index] = currElementInPos;
                    }
                    else if (direction === 'up' && index - i > 0) {
                        currElementInPos = allGroupings[index - 1];
                        allGroupings[index - 1] = groupItem;
                        allGroupings[index] = currElementInPos;
                    }
                }
            }

            /* reset sortOrder property and let ChartSetupDataBinding.SortGroupings() take care of it */
            for (var j = 0; j < allGroupings.length; j++)
                allGroupings[j].sortOrder = 0;

            ChartSetupDataBinding.SortGroupings();
            ChartSetupDataBinding.UpdateGroupings();

            HTMLHelpers.setSelectedValues('#' + elementid, selItems);

            if ($("#ddlAxisSort").val() == 7) { // otherChart
                var foreignDataGroupId = Storyboard.FilterSort.getSelections().axis.foreignDataGroupId;
                Storyboard.FilterSort.reloadCharts(foreignDataGroupId);
            }
        },
        changeOrderDrag: function (evt, ui) {
            var allGroupings = ChartSetupDataBinding.GetBoundDataGroup().groupedItems;
            $('.groupingsConnect li').each(function(i, elem) {
                var groupingValue = $(this).attr('data-value');
                var groupedItem = ChartSetupDataBinding.GetGroupingByValue(groupingValue);

                if (groupedItem) groupedItem.sortOrder = i + 1;
            });

            allGroupings.sort(function (a, b) {
                if (a.sortOrder > b.sortOrder) return 1;
                if (a.sortOrder < b.sortOrder) return -1;

                return 0;
            });

            /* reset sortOrder property and let ChartSetupDataBinding.SortGroupings() take care of it */
            for (var i = 0; i < allGroupings.length; i++)
                allGroupings[i].sortOrder = 0;

            ChartSetupDataBinding.SortGroupings();
            ChartSetupDataBinding.UpdateGroupings();

            if ($("#ddlAxisSort").val() == 7) { // otherChart
                var foreignDataGroupId = Storyboard.FilterSort.getSelections().axis.foreignDataGroupId;
                Storyboard.FilterSort.reloadCharts(foreignDataGroupId);
            }
        },
        moveItems: function (sender) {
            var axis = Storyboard.Constants.Axis;
            var lbmovefrom = ($(sender).attr("id") === "btnMoveToLegend") ? "#lbAxis" : "#lbLegend";
            var targetAxis = ($(sender).attr("id") === "btnMoveToLegend") ? axis.legend : axis.axis;

            var items = $(lbmovefrom).val();
            $(items).each(function () {
                ChartSetupDataBinding.GetGroupingByValue(this).position = targetAxis;
            });

            ChartSetupUI.updateBenchmarkOptions();
            ChartSetupUI.updateRankingObjects();
            // update sortOrder
            var allGroupings = ChartSetupDataBinding.GetBoundDataGroup().groupedItems;
            for (var i = 0; i < allGroupings.length; i++)
                allGroupings[i].sortOrder = 0;
            ChartSetupDataBinding.SortGroupings();

            ChartSetupDataBinding.UpdateGroupings();

            if ($("#ddlAxisSort").val() == 7) { // otherChart
                var foreignDataGroupId = Storyboard.FilterSort.getSelections().axis.foreignDataGroupId;
                Storyboard.FilterSort.reloadCharts(foreignDataGroupId);
            }
        },
        dragItems: function (evt, ui, targetAxis) {
            var axis = Storyboard.Constants.Axis;
            var groupingValue = ui.item.attr('data-value');

            if (!targetAxis)
                targetAxis = ($(ui.sender).closest(".groupingsConnect").attr("id") == "lbAxisList") ? axis.legend : axis.axis;

            if (groupingValue === 'filter') {
                $(ui.item).find('li').each(function() {
                    ChartSetupDataBinding.GetGroupingByValue($(this).attr('data-value')).position = targetAxis;
                });
            } else {
                ChartSetupDataBinding.GetGroupingByValue(groupingValue).position = targetAxis;
            }
        },
        updateSortingOptions: function () {

            // if hfilter is present sorting should be allow sort by level/branch
            for (var i = 0; i < 2; i++) {
                var boxId = i == 0 ? "#lbAxis" : "#lbLegend";
                var sortDdlId = i == 0 ? "#ddlAxisSort" : "#ddlLegendSort";

                if ($(boxId + " option[value='0']").length > 0) {
                    $(sortDdlId + " option[value='0']").html("Internal order ascending - by level");
                    $(sortDdlId + " option[value='5']").html("Internal order descending - by level");

                    if ($(sortDdlId + " option[value='10']").length < 1)
                        $(sortDdlId + " option[value='0']").after("<option value='10'>Internal order ascending - by branch</option>");
                    if ($(sortDdlId + " option[value='11']").length < 1)
                        $(sortDdlId + " option[value='0']").after("<option value='11'>Internal order descending - by branch</option>");
                } else {
                    $(sortDdlId + " option[value='0']").html("Internal order ascending");
                    $(sortDdlId + " option[value='5']").html("Internal order descending");

                    if ($(sortDdlId).val() == 11)
                        $(sortDdlId).val(5);
                    else if ($(sortDdlId).val() == 10)
                        $(sortDdlId).val(0);

                    $(sortDdlId + " option[value='11'], " + sortDdlId + " option[value='10']").remove();
                }
            }
        },
        updateGroupingsAvailabillity: function (groupingItemValue, box) {
            var availabillity = (box.find('option:selected').length > 0 ? true : false),
                groupingItemEl = $('.groupingsConnect li[data-value="' + groupingItemValue + '"]');

            groupingItemEl.toggleClass('ui-state-disabled', !availabillity);

            if (availabillity === true) {
                var groupingItem = ChartSetupDataBinding.GetGroupingByValue(groupingItemValue);
                var selectedTexts = ($.map(box.find('option:selected'), function (item, i) { return $(item).text() }).join(", "));
                if (groupingItem !== null) {
                    groupingItemEl.text(groupingItem.text + ' (' + selectedTexts + ')');
                    ChartSetupUI.updateShowTextButtons(groupingItem.value, groupingItemEl);
                }
            }
        },
        updateNestedFiltersGroupings: function () {
            var nested = $("#chbNestCompareFilters").is(':checked');
            var axisFilters = $('#lbAxisList > li[title^="Filter "]');
            var legendFilters = $('#lbLegendList > li[title^="Filter "]');

            if (!nested && (axisFilters.length > 0 || legendFilters.length > 0)) {
                axisFilters.find('span').each(function() { $(this).text($(this).text().replace(/Filter \(|\)$/g, "")) });
                legendFilters.find('span').each(function() { $(this).text($(this).text().replace(/Filter \(|\)$/g, "")) });
                axisFilters.first().before('<li data-value="filter" class="groupingsConnectItem groupingsFilters"><span>Filters</span><ul></ul></li>');
                legendFilters.first().before('<li data-value="filter" class="groupingsConnectItem groupingsFilters"><span>Filters</span><ul></ul></li>');
                $('#lbAxisList .groupingsFilters > ul').append(axisFilters);
                $('#lbLegendList .groupingsFilters > ul').append(legendFilters);

                ChartSetupUI.updateShowTextButtons('filter', $('.groupingsConnect > li.groupingsFilters'));
            } else {
                ChartSetupUI.updateShowTextButtons('filter', $('.groupingsConnect > li[title^="Filter "]'));
            }
        },
        updateShowTextButtons: function(groupingValue, groupingItemEl) {
            var showTextControl;
            var button = '<button type="button" class="DUIButtonIcon btnShowText ${active}" title="'+ locale.get("Show Text") +'">'+
                '<i class="DUI-icon DUI-icon-hide"></i>'+
                '</button>';

            if      (groupingValue === "question")   showTextControl = $("#cbShowQuestionTexts");
            else if (groupingValue === "answer")     showTextControl = $("#cbShowAnswerTexts");
            else if (groupingValue === "timeperiod") showTextControl = $("#cbShowTimeIntervalTexts");
            else if (groupingValue === "filter")     showTextControl = $("#cbShowFilterTexts");

            groupingItemEl.prepend(button.replace("${active}", showTextControl.attr("checked") ? "active" : ""));

            groupingItemEl.find(".btnShowText").bind("click", function() {
                $(this).toggleClass("active");
                showTextControl.attr("checked", $(this).hasClass("active"));
                if (groupingValue === "filter")
                    $('.groupingsConnect li[title^="Filter "] .btnShowText, .groupingsConnect > li.groupingsFilters .btnShowText')
                        .toggleClass("active", $(this).hasClass("active"));
            });

            showTextControl.unbind("change.showTextButton").bind("change.showTextButton", function() {
                if (this.id === "cbShowFilterTexts") {
                    $('.groupingsConnect li[title^="Filter "] .btnShowText, .groupingsConnect > li.groupingsFilters .btnShowText')
                        .toggleClass("active", $(this).attr("checked"));
                } else {
                    $('.groupingsConnect li[data-value="'+ groupingValue +'"] .btnShowText')
                        .toggleClass("active", $(this).attr("checked"));
                }
            });
        },
        addFilterToGrouping: function (sender, position) {
            var filtertext = 'Filter (' + $.trim($(".filterboxHeaderWrapper h3", $(sender).parent()).html()) + ')';
            var filterid = $(sender).siblings("input[type='hidden']").val();

            if ($(sender).attr("checked")) {
                var groupTypes = Storyboard.Constants.GroupTypes;
                var filterPosition = position || this.getFilterPosition();
                var filterGrouping = groupTypes.getGroupItem(filterid, filterPosition,
                    0, '', filtertext);
                ChartSetupDataBinding.EnsureGroupingExists(filterGrouping);
            }
            else
                ChartSetupDataBinding.DeleteGroupingByValue(filterid);

            ChartSetupUI.updateBenchmarkOptions();
            ChartSetupUI.updateRankingObjects();
            ChartSetupDataBinding.UpdateGroupings();
        },
        getFilterPosition: function () {
            var filterPosition;
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var isMainDataGroup = dataGroup.isMain;

            if (dataGroup.templateGroupedItems && dataGroup.templateGroupedItems.length > 0)
                for (var i = 0; i < dataGroup.templateGroupedItems.length; i++)
                    if (dataGroup.templateGroupedItems[i].groupType == "3")
                        return dataGroup.templateGroupedItems[i].position;

            if (isMainDataGroup &&
                Storyboard.LayoutDesigner.isAdmin &&
                !Helpers.isPreview()) {
                filterPosition = $('#selectDefaultPlacementFilters option:selected').val();
            } else {
                filterPosition = dataGroup.defaultAxisBehavior.filtersPosition;
            }
            return filterPosition;
        },
        addHFilterToGrouping: function (checked) {
            if (checked) {
                var groupTypes = Storyboard.Constants.GroupTypes;
                var filterGrouping = groupTypes.getGroupItem(0, Storyboard.Constants.Axis.legend, 0, '', 'HFilter');
                ChartSetupDataBinding.EnsureGroupingExists(filterGrouping);
            }
            else
                ChartSetupDataBinding.DeleteGroupingByValue(0);

            ChartSetupUI.updateBenchmarkOptions();
            ChartSetupUI.updateRankingObjects();
            ChartSetupDataBinding.UpdateGroupings();
            ChartSetupUI.showHideHFilterColorSource();
        },
        showHideHFilterColorSource: function () {
            var hasComparison = $("#hFilterSelectedComparisonGroups tr td.selection").length > 1;
            if (hasComparison)
                DataGroupSelections.ShowOption('#ddlColorLogic', Storyboard.Constants.ColorSources.HFILTER_RULE);
            else
                DataGroupSelections.HideOption('#ddlColorLogic', Storyboard.Constants.ColorSources.HFILTER_RULE);

            ChartSetupUI.showHideHFilterRuleColors();
        },
        showHideHFilterRuleColors: function () {
            $('.hfRuleColorCell').toggle($('#ddlColorLogic').val() == Storyboard.Constants.ColorSources.HFILTER_RULE);
        },
        showHideValueBasedColors: function () {
            $('#valueBasedColorsDiv').toggle($('#ddlColorLogic').val() == Storyboard.Constants.ColorSources.VALUE_BASED);
        },
        nestCompareFilters: function() {
            ChartSetupDataBinding.UpdateGroupings();
        },
        updateCompareFilterWeightSelections: function() {

            var $allWeightedFilters = getAllWeighedFilters();
            if(!$allWeightedFilters.length)
                return;

            var $regularWeightedFilters = getRegularWeightedFilters($allWeightedFilters);
            if($regularWeightedFilters.length)
                removeWeightCheckboxFromRegularFilters($regularWeightedFilters);

            var $compareFilterBoxes = getWeightedCompareFilters($allWeightedFilters);
            if(!$compareFilterBoxes.length)
                return;

            if($("#chbNestCompareFilters").is(':checked'))
                updateWeightCheckboxesForNestedCompareFilters($compareFilterBoxes);
            else
                updateWeightCheckboxesForNonNestedCompareFilters($compareFilterBoxes);
        },
        bindAxisLegendItemsToDdl: function (dropdownId, selectedValue, axis, noSelLabel, noSelValue) {
            var selectBox = axis == 1 ? '#lbLegendList' : '#lbAxisList';
            var options = $.map($(selectBox + ' > li'), function (e) {
                if ($(e).attr('data-value') === 'filter') {
                    var filterIds = $(e).find('li').map(function (i, f) {
                        return $(f).attr('data-value');
                    }).get().join(',');
                    var filterTexts = locale.get($(e).find('> span').text()) +
                        ' (' + ($(e).find('li').map(function (i, f) { return $(f).text(); }).get().join(', ')) + ')';
                    return { id: filterIds, text: filterTexts, type: $(e).attr('type') };
                } else {
                    return { id: $(e).attr('data-value'), text: $(e).text() ? $('<div/>').text(locale.get($(e).text())).html() : '', type: $(e).attr('type') };
                }
            });

            HTMLHelpers.bindSelect(dropdownId, options, 'id', 'text', noSelLabel, true, noSelValue);
            HTMLHelpers.setSelectedValues(dropdownId, selectedValue || noSelValue);
        },
        showHideNoLetters: function () {
            var testType = $("#ddlDataTestType").val();
            if (testType == 4 || testType == 5)
                HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlSigStartingLetter'), '[value="none"]'));
            else
                HTMLHelpers.optionToComment($("#ddlSigStartingLetter option[value='none']"));
        },
        hideShowBenchmark: function () {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var validForSeriesTest = true;

            $('#benchmarkPanel').show();
            if (dataGroup.isMain) {
                var allDgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(dataGroup);
                validForSeriesTest = allDgs.length > 1;
            } else {
                validForSeriesTest = false;

                var mainDg = Storyboard.DataGroupLogic.getMainDataGroupForLayoutElementItem(dataGroup.guid);
                if (mainDg.benchmarkSettings.isEnabled && mainDg.benchmarkSettings.axis == 3) { // series compare, setting should not be available is subgroup
                    $('#benchmarkPanel').hide();
                }
            }

            if (validForSeriesTest) {
                if ($("#ddlBenchmarkAxis option[value='3']").length === 0)
                    HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlBenchmarkAxis'), '[value="3"]'));
            } else {
                if ($("#ddlBenchmarkAxis").val() == 3)
                    HTMLHelpers.setSelectedValues("#ddlBenchmarkAxis", 1);
                HTMLHelpers.optionToComment($("#ddlBenchmarkAxis option[value='3']"));
            }
        },
        enableBenchmark: function () {
            var enable = $("#chkEnableBenchmark").attr("checked");
            $(".fsBenchmark").css('display', enable ? '' : 'none');
            ChartSetupUI.hideForBenchmarkOptions();
        },
        updateBenchmarkOptions: function (selectedBenchmarkFilter) {
            var benchmarkAxis = parseInt($('#ddlBenchmarkAxis').val(), 10);
            if (selectedBenchmarkFilter === undefined || selectedBenchmarkFilter === null)
                selectedBenchmarkFilter = $('#ddlBenchmarkGrouping').val();
            ChartSetupUI.bindAxisLegendItemsToDdl('#ddlBenchmarkGrouping', selectedBenchmarkFilter, benchmarkAxis);
            if ($("#ddlBenchmarkGrouping").val() === null)
               $("#ddlBenchmarkGrouping").val($("#ddlBenchmarkGrouping option:first").val());

            // hide group object when test is run between series
            $('#ddlBenchmarkGrouping').closest('.settingItem').toggle(benchmarkAxis !== 3);

            ChartSetupUI.hideBenchmarkCompareTypeOptions();
            ChartSetupUI.showHideBenchmarkSorting();
        },
        showHideBenchmarkTextMatch: function () {
            var benchmarkAxis = parseInt($('#ddlBenchmarkAxis').val(), 10);
            var matchBy = parseInt($('#ddlBenchmarkMatchBy').val(), 10) || 1;
            $('#ddlBenchmarkMatchByText').toggle(matchBy === 2 && benchmarkAxis === 3);
        },
        showHideSigTextMatch: function () {
            var sigCompareType = parseInt($('#ddlDataCompareType').val(), 10);
            var matchBy = parseInt($('#ddlSigTextMatchBy').val(), 10) || 1;
            $('#ddlSigTestMatchByText').toggle(matchBy === 2 && sigCompareType === 3);
            $('.sgtTextMatchLogic').toggle(matchBy === 2 && sigCompareType === 3);
        },
        hideBenchmarkCompareTypeOptions: function () {
            var hide = $("#chkEnableBenchmark").attr("checked") && $('#chbShowOnlyBenchmarks').attr('checked');
            var benchmarkAxis = parseInt($('#ddlBenchmarkAxis').val(), 10);

            var dataTT = $('#ddlBenchmarkComparisonType').val();
            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlBenchmarkComparisonType')));
            if (benchmarkAxis === 3) {
                HTMLHelpers.optionToComment($('#ddlBenchmarkComparisonType option:not(.betweenSeries)'));
                $('.bmMatchSeriesBy').show();
                $('#ddlBenchmarkFoldingOption option').each(function () {
                    $(this).text($(this).text().replace('points', 'series'));
                });
                ChartSetupUI.showHideBenchmarkTextMatch();
            } else {
                HTMLHelpers.optionToComment($('#ddlBenchmarkComparisonType option.betweenSeries'));
                $('#ddlBenchmarkFoldingOption option').each(function () {
                    $(this).text($(this).text().replace('series', 'points'));
                });
                $('.bmMatchSeriesBy').hide();
            }

            if (hide) {
                HTMLHelpers.optionToComment($('#ddlBenchmarkComparisonType > option[value="1"], #ddlBenchmarkComparisonType > option[value="3"]'));
            }

            $('#ddlBenchmarkComparisonType > option[value="' + dataTT + '"]:first').attr('selected', true);
        },
        hideForBenchmarkOptions: function () {
            var hide = $("#chkEnableBenchmark").attr("checked") && $('#chbShowOnlyBenchmarks').attr('checked');
            var contentType = ChartSetupDataBinding.GetBoundContentType();

            if (hide) {
                var selected = $('#ddlBenchmarkComparisonType > option:selected').val();
                if (selected == 1 || selected == 3) // we will hide these, so select Previous datapoint one
                    HTMLHelpers.setSelectedValues('#ddlBenchmarkComparisonType', 2);
                $('.hdPosNeg, #percentilePanel, #tableBenchmarkPlacement, #siBenchmarkComparisonBehavior').hide();

                var isMainDg = ChartSetupDataBinding.GetBoundDataGroup().isMain;
                if (!isMainDg) {
                    var mainDg = Storyboard.GuiEvents.DataGroupEdit.getDataGroups().filter(function (dg) { return dg.isMain; })[0];
                    if (!mainDg.benchmarkSettings || !mainDg.benchmarkSettings.isEnabled || !mainDg.benchmarkSettings.showBenchmarkOnly || mainDg.benchmarkSettings.axis != 3)
                        $('.hdMeanValueSeries').hide();
                } else {
                    $('.hdMeanValueSeries').hide();
                }

                ChartSetupUI.enableBenchmarkSorting();
            }
            else {
                $('hdPosNeg, #siBenchmarkComparisonBehavior').show();

                if (contentType == Storyboard.Constants.itemTypes.CHART) {
                    var seriesType = parseInt($('#ddlSeriesType').val(), 10);
                    var st = Storyboard.Constants.SeriesTypes;
                    if (!(seriesType == st.PIE || seriesType == st.DONUT || seriesType == st.BUBBLE || seriesType == st.SCATTER || seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE || seriesType == st.HEATMAP || seriesType == st.MARIMEKKO))
                        $('#percentilePanel').show();
                    if (!(seriesType == st.PIE || seriesType == st.DONUT || seriesType == st.SOLIDGAUGE || seriesType == st.MARIMEKKO))
                        $('.hdMeanValueSeries').show();
                } else if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE)
                    $('#tableBenchmarkPlacement, .hdMeanValueSeries').show();
            }

            ChartSetupUI.showHideBenchmarkSorting();
            ChartSetupUI.hideBenchmarkCompareTypeOptions();
            ChartSetupUI.disableSigTest($('#ddlSeriesType').val());
        },
        showHideBenchmarkSorting: function () {
            var hide = $("#chkEnableBenchmark").attr("checked") && $('#chbShowOnlyBenchmarks').attr('checked');
            if (hide && parseInt($('#ddlBenchmarkAxis').val(), 10) !== 3)
                $('.siBenchmarkSorting').show();
            else
                $('.siBenchmarkSorting').hide();
        },
        enableBenchmarkSorting: function () {
            var enable = $('#chbSortBenchmarks').attr('checked');

            if (enable) $('#ddlBenchmarkSorting').show();
            else $('#ddlBenchmarkSorting').hide();
        },
        updateSigTestOptions: function (testType, testItem) {
            var previousValue = testItem || $('#ddlDataCompareItem').val();
            $('#ddlDataCompareItem option[value!="0"]').remove();

            if (testType == 2) { // axis items (rows)
                ChartSetupUI.bindAxisLegendItemsToDdl('#ddlDataCompareItem', previousValue, 2, locale.get('All items'), 0);
            }
            else {
                ChartSetupUI.bindAxisLegendItemsToDdl('#ddlDataCompareItem', previousValue, 1, locale.get('All items'), 0);
            }

            if ($("#ddlAnalysisType").val() == 2 || testType == 3) {
                $("#ddlDataCompareItem").val(0);
                $("#ddlDataCompareItem").closest(".settingItem").hide();
            } else
                $("#ddlDataCompareItem").closest(".settingItem").show();

            var dataTT = $("#ddlDataTestType").val();
            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlDataTestType")));
            if (testType == 3) {
                HTMLHelpers.optionToComment($("#ddlDataTestType option:not(.betweenSeries)"));
            } else {
                HTMLHelpers.optionToComment($("#ddlDataTestType option.betweenSeries"));
            }
            $("#ddlDataTestType > option[value='" + dataTT + "']:first").attr("selected", true);

            if (testType == 3)
                $("#ddlSigTextMatchBy").closest(".settingItem").show();
            else
                $("#ddlSigTextMatchBy").closest(".settingItem").hide();
        },
        configureSigTestType: function (calculationType){

            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            calculationType = calculationType || dataGroup.calculationType;
            var testType = $('#ddlDataCompareType').val();

            if (ChartSetupUI.checkIfNormTestAvailable(calculationType)) {
                HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), '[value="2"]'));

                if ($("#ddlAnalysisType").val() == 2) {
                    $("#ddlNormSeries").closest(".settingItem").show();
                    $("#ddlSigTextMatchBy").closest(".settingItem").show();

                    // Hide not relevant fields
                    $("#ddlBaseSizeType").closest(".settingItem").hide();
                    $("#ddlDataCompareType").closest(".settingItem").hide();
                    $("#ddlDataCompareItem").closest(".settingItem").hide();
                    $("#ddlDataTestType").closest(".settingItem").hide();

                    if ($("#ddlDataCompareType").val() != 3) {
                        $("#ddlDataCompareType").data("oldValue", $("#ddlDataCompareType").html());
                        if ($("#ddlDataCompareType option[value='3']").length === 0)
                            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlDataCompareType'), '[value="3"]'));

                        $("#ddlDataCompareType option[value='3']").attr("selected", "selected");
                    }

                    $("#ddlDataTestType").val('2');
                    $(".sigResultToShow").toggle($("#ddlAnalysisType").val() == "2" || $("#ddlDataTestType").val() == "1");
                    var contentType = ChartSetupDataBinding.GetBoundContentType();
                    if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE)
                        $("#sigVisualizationType").show();
                } else {
                    $("#ddlNormSeries").closest(".settingItem").hide();

                    // show all fields
                    $("#ddlBaseSizeType").closest(".settingItem").show();

                    $("#ddlDataCompareType").closest(".settingItem").show();
                    if ($( "#ddlDataCompareType option:selected" ).val() != 3)
                        $("#ddlDataCompareItem").closest(".settingItem").show();
                    if (testType == 3)
                        $("#ddlSigTextMatchBy").closest(".settingItem").show();
                    else
                        $("#ddlSigTextMatchBy").closest(".settingItem").hide();
                    $("#ddlDataTestType").closest(".settingItem").show();

                    $(".sigResultToShow").toggle($("#ddlAnalysisType").val() == "2" || $("#ddlDataTestType").val() == "1");
                }

                ChartSetupUI.showHideSigTestVisualization();
            } else {
                if (dataGroup.calculationType == Storyboard.Constants.CalculationTypes.NUMERIC_AVERAGE)
                    $("#ddlAnalysisType").children("option[value='3']").attr("selected", true);

                HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='2']"));
                $("#ddlNormSeries").closest(".settingItem").hide();

                // show all fields
                $("#ddlBaseSizeType").closest(".settingItem").show();

                $("#ddlDataCompareType").closest(".settingItem").show();
                if ($("#ddlDataCompareType option:selected").val() != 3)
                    $("#ddlDataCompareItem").closest(".settingItem").show();
                $("#ddlDataTestType").closest(".settingItem").show();
            }

            if (dataGroup.significanceOptions.seriesMatchType === 1 || dataGroup.significanceOptions.seriesMatchType === 5) {
                $('#ddlSigTextMatchBy').val(dataGroup.significanceOptions.seriesMatchType);
            } else {
                $('#ddlSigTextMatchBy').val(2);
                $('#ddlSigTestMatchByText').val(dataGroup.significanceOptions.seriesMatchType);
                $('#ddlTextMatchType').val(dataGroup.significanceOptions.textMatchType || 1);
            }
            ChartSetupUI.showHideSigTextMatch();

            ChartSetupUI.showHideSigTestBaseTypeByAnalysisType();
            $("#ddlSigTestHidePoints").closest(".settingItem").css("display", ($("#ddlAnalysisType").val() != "2" && $("#ddlDataTestType").val() == "1") ? "none" : "");
            ChartSetupUI.showHideSigTestValuesTooltip();
        },
        showHideSigTestValuesTooltip: function () {
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();

            $('#sigShowValuesInTooltip').toggle(contentType == Storyboard.Constants.itemTypes.CHART && dataGroup.isMain &&
                $("#ddlAnalysisType").val() == 3 && $('#ddlDataTestType').val() != 1);
        },
        showHideSigTestBaseTypeByAnalysisType: function () {
            var analysisType = $("#ddlAnalysisType").val();

            if (analysisType == Storyboard.Constants.AnalysisTypes.TWO_INDEPENDENT_SAMPLE_T_TEST) {
                $('#sigTestHelp').hide();
                $("#ddlBaseSizeType").find("option[value='3']").text("Unweighted");
                if ($("#ddlBaseSizeType").val() == 2)
                    $("#ddlBaseSizeType").val(3);
                HTMLHelpers.optionToComment($("#ddlBaseSizeType option[value='2']"));
            } else {
                $('#sigTestHelp').show();
                $("#ddlBaseSizeType").find("option[value='3']").text("Unweighted - Option B");
                HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlBaseSizeType'), '[value="2"]'));
            }
        },
        updateHeatMapLegendBox: function () {
            var groupTypes = Storyboard.Constants.GroupTypes;
            var consts = Storyboard.Constants;
            var answerBased = Storyboard.Constants.CalculationTypes.isAnswerBased($('#ddlCalculationType option:selected').val());

            var options = [];
            if ($("#answerbox option:selected").length == 1)
                options.push(groupTypes.getGroupItem(groupTypes.ANSWER_VAL, consts.Axis.legend, 0, ''));
            if ($("#questionBox option:selected").length == 1)
                options.push(groupTypes.getGroupItem(groupTypes.QUESTION_VAL, consts.Axis.legend, 0, ''));

            HTMLHelpers.bindSelect("#ddlHeatMapLegend", options, 'groupType', 'text', 'None', true);

            if (answerBased) {
                $("#ddlHeatMapLegend").val(Storyboard.Constants.GroupTypes.getGroupType("Answer"));
            } else {
                $("#ddlHeatMapLegend").val(Storyboard.Constants.GroupTypes.getGroupType("Question"));
            }
        },
        initDefaults: function (calctype) {
            ChartSetupProxy.GetDefaultQuestions(calctype);
        },
        hideFilterPanel: function (sender, id) {
            if (!$(sender).attr("checked")) {
                $("#" + id).slideUp('fast');
                $("#" + id).find("select>option").removeAttr("selected");
                ChartSetupDataCom.FilterQuestions();
            }
            else {
                $("#" + id).slideDown('fast');
            }
        },
        disableForSelectedQuestions: function () {
            $("#correlationQuestionBox option").removeAttr("disabled");
            $("#questionBox option:selected").each(function () {
                $("#correlationQuestionBox option[value='" + $(this).val() + "']").attr("disabled", "disabled");
                if ($("#correlationQuestionBox").val() == $(this).val())
                    $("#correlationQuestionBox").val($("#correlationQuestionBox option:enabled:first").val());
            });
        },
        hideAnswerSelections: function (showAnswer) {
            if (!showAnswer) {
                $("#answerbox").parent().css("display", "none");
                $("#answerbox option").attr("selected", false);
            }
            else {
                $("#answerbox").parent().css("display", "");
            }
        },
        hideCorrelationSettings: function (showCorrelationSettings) {
            $(".hdCorrelationOption").toggle(showCorrelationSettings);
            if (!showCorrelationSettings) {
                $("#correlationQuestionBox").parent().css("display", "none");
                $("#correlationQuestionBox option").attr("selected", false);
            }
            else
                $("#correlationQuestionBox").parent().css("display", "");
        },
        showHideDateSelections: function () {
            var timePeriod = $("#ddlTimePeriod").val();
            if (timePeriod === consts.static_time)
                $("#txtStartDate, #txtStopDate").parent().show();
            else
                $("#txtStartDate, #txtStopDate").parent().hide();

            if (timePeriod === "27")
                $("#txtTimePeriod, #ddlTimePeriodSpan").show();
            else
                $("#txtTimePeriod, #ddlTimePeriodSpan").hide();
        },
        showTimeSettingsComparationOptions: function (selectedTimePeriod) {
            var timePeriod = $("#ddlTimePeriod").val();
            var ddlTimePeriodSpan = $("#ddlTimePeriodSpan").val();
            var chbIncludePreviousPeriods = $("#chbIncludePreviousPeriods");
            var chbIncludeTheSamePeriodOfPreviousYears = $("#chbIncludeTheSamePeriodOfPreviousYears");

            var lblIncludeTheSamePeriodOfPreviousYearsNote = $("#lblIncludeTheSamePeriodOfPreviousYearsNote");
            var lblIncludePreviousPeriodsNote = $("#lblIncludePreviousPeriodsNote");
            var lblYears = $("#lblYears");
            var timeSelectionsPreviousYears = $("#timeSelectionsPreviousYears");
            var btnAdvTimeComparisons = $('#btnAdvTimeComparisons');
            var chbIncludePreviousPeriodsVisible = true;
            var chbIncludeTheSamePeriodOfPreviousYearsVisible = true;

            if (selectedTimePeriod) {
                chbIncludePreviousPeriods.parents("table").show();
                lblIncludeTheSamePeriodOfPreviousYearsNote.show();
                lblIncludePreviousPeriodsNote.show();
                lblYears.html("year(s)*");
                timeSelectionsPreviousYears.addClass("timeSelectionsPreviousYears");
            } else {
                chbIncludePreviousPeriods.parents("table").hide();
                chbIncludePreviousPeriodsVisible = false;
                lblIncludeTheSamePeriodOfPreviousYearsNote.hide();
                lblIncludePreviousPeriodsNote.hide();
                lblYears.html("year(s)");
                timeSelectionsPreviousYears.removeClass("timeSelectionsPreviousYears");
            }

            if (selectedTimePeriod || (timePeriod === "27" && ddlTimePeriodSpan === "3") || (timePeriod === "27" && ddlTimePeriodSpan === "4") || (timePeriod === "18")) {
                chbIncludeTheSamePeriodOfPreviousYears.parents("table").show();
            } else {
                chbIncludeTheSamePeriodOfPreviousYears.parents("table").hide();
                chbIncludeTheSamePeriodOfPreviousYearsVisible = false;
            }

            if (chbIncludeTheSamePeriodOfPreviousYearsVisible || chbIncludePreviousPeriodsVisible)
                btnAdvTimeComparisons.show();
            else
                btnAdvTimeComparisons.hide();
        },
        setTimePeriodInfoMessage: function (timePeriod, interval, movingAverage) {
            var cnt = (timePeriod ? 1 : 0) + (interval ? 1 : 0) + (movingAverage ? 1 : 0)
            $("#lblTimePeriodInfo").find("span").html("Note: "
                + (timePeriod ? "Time period" : "")
                + (timePeriod ? (cnt === 1 ? "" : (cnt === 2 ? " and " : ", ")) : "")
                + (interval ? "Interval" : "")
                + (interval ? (cnt === 1 ? "" : (cnt === 3 ? " and " : (timePeriod && interval ? "" : " and "))) : "")
                + (movingAverage ? "Moving average" : "")
                + " will be overwritten by selections in Optional filters.");
        },
        filterNoSelection: function (selectbox, skipGroupingsCheck) {
            var nofilterselect = $(selectbox);
            var chkBox = nofilterselect.siblings("input:checkbox");
            if (nofilterselect.val() == "0") {
                chkBox.attr("disabled", "disabled");
                chkBox.attr("checked", false);
                if (!skipGroupingsCheck)
                    ChartSetupUI.addFilterToGrouping(chkBox);
            } else {
                chkBox.removeAttr("disabled");
            }
        },
        disableRespCountTooltip: function () {
            var calcType = parseInt($("#ddlCalculationType").val(), 10);
            var calcTypes = Storyboard.Constants.CalculationTypes;

            if (calcType != calcTypes.CATEGORICAL_COUNT && calcType != calcTypes.CATEGORICAL_PERCENT) {
                $("#chbShowRespondentCount").attr("checked", false);
                $("#chbShowRespondentCount").attr("disabled", "disabled");
            } else
                $("#chbShowRespondentCount").removeAttr("disabled");
        },
        disableForCalcType: function (calcType) {
            var calcTypes = Storyboard.Constants.CalculationTypes;

            if (calcType == calcTypes.CATEGORICAL_PERCENT)
                $("#ddlTrimLowResultObject option[value=2]").removeAttr("disabled");
            else {
                $("#ddlTrimLowResultObject option[value=1]").attr("selected", "selected");
                $("#ddlTrimLowResultObject option[value=2]").attr("disabled", "disabled");
                ChartSetupUI.disableHideLowResultBaseType();
            }

            if (calcType == calcTypes.CATEGORICAL_MEAN && !$("#ddlSeriesOptions option[value='0']").attr("selected"))
                $("#ddlSeriesOptions option[value='0']").attr("selected", "selected");

            if (calcType == calcTypes.CORRELATION_ANALYSIS)
                $("#tabChartAnalysis").hide(); // TODO: disable analysis settings? here or on save maybe?
            else $("#tabChartAnalysis").show();

            ChartSetupUI.disablePosNeg();
            ChartSetupUI.disableChartLogicAnswer(!calcTypes.isAnswerBased(calcType));
        },
        disableChartLogicAnswer: function (hideAnswer) {
            var answerOption = Storyboard.Constants.ColorSources.ANSWER;
            if (hideAnswer && $("#ddlColorLogic").val() == answerOption)
                $("#ddlColorLogic").val(Storyboard.Constants.ColorSources.AUTO);

            var dependentItems = $("#cbShowAnswerTexts, #cbShowAnswerTexts + label, #ddlColorLogic option[value='" + answerOption + "']");
            if (hideAnswer)
                $(dependentItems).attr("disabled", true);
            else
                $(dependentItems).removeAttr("disabled");

            if (hideAnswer && $("#cbShowAnswerTexts").attr("checked"))
                $("#cbShowAnswerTexts").removeAttr("checked");
        },
        disablePosNeg: function () {
            var calcType = parseInt($("#ddlCalculationType").val(), 10);
            var seriesType = parseInt($('#ddlSeriesType').val(), 10);
            var seriesTypes = Storyboard.Constants.SeriesTypes;
            var calcTypes = Storyboard.Constants.CalculationTypes;
            var isPieLikeSeriesType = (seriesType === seriesTypes.PIE || seriesType === seriesTypes.DONUT);
            if (calcType == calcTypes.CATEGORICAL_PERCENT && !isPieLikeSeriesType)
                $("#chkApplyPosNeg").removeAttr("disabled");
            else {
                $("#chkApplyPosNeg").attr("disabled", "disabled");
                $("#chkApplyPosNeg").attr("checked", false);
            }
        },
        showHideSigTestVisualization: function () {
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            var compareType = $("#ddlDataTestType").val();
            var analysisType = $('#ddlAnalysisType').val();
            if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
                if (analysisType !== "2" && compareType == "1") {
                    $("#ddlSigVisualizationType").val(1);
                    $("#sigVisualizationType").hide();
                } else
                    $("#sigVisualizationType").show();

                $("#sigTestIconSettings").css("display", $("#ddlSigVisualizationType").val() == 3 ? "" : "none");
                $("#sigPlacementOptionLabel").css("display", $("#ddlSigVisualizationType").val() == 1 ? "" : "none");

                // Reverting ddlSigSymbolsSet to available value when switching to another SifVisualizationType
                if ($("#ddlSigVisualizationType").val() != 1 && $("#ddlSigSymbolsSet").find("option:selected").text().trim() === ",") {
                    const $otherValue = $("#ddlSigSymbolsSet").find("option").filter(function () {
                        return $(this).text().trim() !== ",";
                    });
                    if ($otherValue.length) {
                        $("#ddlSigSymbolsSet").val($otherValue.val())
                    }
                }

            } else
                $("#sigVisualizationType").hide();

            $("#sigSymbols").css("display", $("#ddlSigVisualizationType").val() == 1 ? "" : "none");
            $("#sigSymbolColors").css("display", ($("#ddlSigVisualizationType").val() == 1 && contentType == Storyboard.Constants.itemTypes.CHART) ? "" : "none");
            $("#sigLetters").css("display", ($("#ddlSigVisualizationType").val() == 1 && compareType != "2" && compareType != 3
                && $("#ddlSigTestHidePoints").val() != 1) ? "" : "none");

            ChartSetupUI.showHideNoSymbolsSigTest();
        },
        showHideNoSymbolsSigTest: function () {
            var noSymbolsVisible = $('#ddlDataTestType').val() == 1 && $('#ddlSigResultToShow').val() != 1; // All vs. All + Positive/Negative only
            if (noSymbolsVisible)
                HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlSigSymbolsSet'), '[value="99"]'));                
            else {
                if ($("#ddlSigSymbolsSet").val() == 99) HTMLHelpers.setSelectedValues("#ddlSigSymbolsSet", "1");
                HTMLHelpers.optionToComment($("#ddlSigSymbolsSet option[value='99']"));
            }
		},
        disableSigTest: function (seriesType) {
            var st = Storyboard.Constants.SeriesTypes;
            var showOnlyBenchmark = $("#chkEnableBenchmark").attr("checked") && $('#chbShowOnlyBenchmarks').attr('checked');

            if (seriesType == st.SCATTER || seriesType == st.BUBBLE ||
                seriesType == st.PIE || seriesType == st.DONUT || seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE) {
                $(".hdStatistics").css("display", "none");
                $("#chkSignificance").attr("checked", false).trigger('change');
                $("#chkSignificance").attr("disabled", "disabled");
            }
            else {
                $(".hdStatistics").css("display", "");
                $("#chkSignificance").removeAttr("disabled");
            }

            var calculationType = $('#ddlCalculationType option:selected').val();
            var anyIndexedQuestions = $('#questionBox option:selected').filter('[isIndexed="true"]').length > 0;


            // Hide Sig Test if index questions are added and the calculation type is Mean (TFS 23498)
            if (anyIndexedQuestions && calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_MEAN) {
                $('.hdStatistics').hide();
            }
            // Calculation type not numeric or numeric mean
            else if (calculationType <= 3) {
                $('#hdCalculationOptions').hide();
                $('#ddlGroupDataBy').val('0');

                if (calculationType != Storyboard.Constants.CalculationTypes.CATEGORICAL_COUNT &&
                    !(seriesType == st.PIE || seriesType == st.DONUT ||
                        seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE || seriesType == st.SCATTER || seriesType == st.BUBBLE)) {
                    $('.hdStatistics').show();

                    HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), '[value="3"]'));
                    if (calculationType < 3) {
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), '[value="1"]'));
                    }

                    // paired sig test - mean and % categorical
                    if (calculationType <= 2) {
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlAnalysisType"), "option[value='4']"));
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlAnalysisType"), "option[value='5']"));
                    } else {
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='4']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='5']")); 
                    }

                    ChartSetupUI.configureSigTestType(calculationType);
                } else {
                    if (ChartSetupUI.checkIfNormTestAvailable(calculationType)) {
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='1']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='3']")); 
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='4']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='5']"));
                        $("#ddlAnalysisType").children("option[value='2']").attr('selected', true);
                        ChartSetupUI.configureSigTestType(calculationType);
                    } else {
                        $('.hdStatistics').hide();
                    }
                }
            } else {
                if (ChartSetupUI.checkIfNormTestAvailable(calculationType)) {
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='1']"));
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='3']"));
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='4']"));
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='5']"));
                    $("#ddlAnalysisType").children("option[value='2']").attr('selected', true);
                    ChartSetupUI.configureSigTestType(calculationType);
                } else {
                    $('#hdCalculationOptions').hide();
                    $("#chkSignificance").attr('checked', false).trigger('change');
                    $('.hdStatistics').hide();
                }
            }

            ChartSetupUI.disableSeriesCompareOptions();

            if (showOnlyBenchmark) {
                $("#ddlSigTestHidePoints").val('0');
                $("#ddlSigTestHidePoints").attr("disabled", "disabled");
            }
            else {
                $("#ddlSigTestHidePoints").removeAttr("disabled");
            }
        },
        checkIfNormTestAvailable: function (calculationType) {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var allDgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(dataGroup);

            return dataGroup.isMain && calculationType < 3 && allDgs.length > 1;

        },
        disableMatchOnText: function () {
            var disableOnRow = $("#chbMatchseries").attr("checked");
            var disableOnColumn = $("#chbMatchSeriesRows").attr("checked");

            if (!disableOnRow && !disableOnColumn) {
                var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
                var allDgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(dataGroup);

                for (var i = 0; i < allDgs.length; i++) {
                    if (allDgs[i].isMain || allDgs[i].dgGuid == dataGroup.dgGuid)
                        continue;

                    if (allDgs[i].seriesSettings.matchSeriesOnColumnText) {
                        disableOnRow = true;
                        break;
                    } else if (allDgs[i].seriesSettings.matchSeriesOnRowText) {
                        disableOnColumn = true;
                        break;
                    }
                }
            }

            if (disableOnColumn)
                $("#chbMatchseries").attr("disabled", "disabled");
            else
                $("#chbMatchseries").removeAttr("disabled");

            if (disableOnRow)
                $("#chbMatchSeriesRows").attr("disabled", "disabled");
            else
                $("#chbMatchSeriesRows").removeAttr("disabled");
        },
        disableSeriesCompareOptions: function () {
            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlDataCompareType")));            
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            if (dataGroup.isMain) {
                var calculationType = $('#ddlCalculationType option:selected').val();
                var allDgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(dataGroup);
                // initial check: object has subseries and main dg is categorical % or mean
                var validForSeriesTest = allDgs.length > 1 && calculationType;

                // loop through subgroups and make sure all series use same calculation type
                for (var dgI = 0; dgI < allDgs.length; dgI++) {
                    if (!allDgs[dgI].isMain && allDgs[dgI].calculationType != calculationType) {
                        validForSeriesTest = false;
                        continue;
                    }
                }

                if (!validForSeriesTest) {
                    if ($("#ddlDataCompareType").val() == 3)
                        HTMLHelpers.setSelectedValues("#ddlDataCompareType", 1);
                    HTMLHelpers.optionToComment($("#ddlDataCompareType option[value='3']"));
                }
            } else {
                var mainDg = Storyboard.DataGroupLogic.getMainDataGroupForLayoutElementItem(dataGroup.guid);
                if (mainDg.significanceOptions.isEnabled && mainDg.significanceOptions.dataCompareType == 3) { // series compare, setting should not be available is subgroup
                    $('.hdStatistics').hide();
                }
                HTMLHelpers.optionToComment($("#ddlDataCompareType option[value='3']"));
            }

            ChartSetupUI.updateSigTestOptions($('#ddlDataCompareType').val());
        },
        disableForSeriesType: function (seriesType, previousType) {

            //THIS METHOD IS DEPRECATED. IT'S WRONG AND IT'S NOT FIRED WHEN IT SHOULD
            //USE ChartSetupSelections.HideGuiElementsByType() instead

            var seriesTypes = Storyboard.Constants.SeriesTypes;
            $("#ddlSeriesOptions option").removeAttr("disabled");
            $(".chartStyleAxisSettings").show();
            if (!seriesTypes.isStackable(seriesType)) {
                $("#ddlSeriesOptions option[value='1']").attr("disabled", 'disabled');
                $("#ddlSeriesOptions option[value='2']").attr("disabled", 'disabled');

                if (!$("#ddlSeriesOptions option[value='0']").attr("selected"))
                    $("#ddlSeriesOptions option[value='0']").attr('selected', 'selected');
            } else if (seriesType == seriesTypes.PIE || seriesType == seriesTypes.DONUT) {
                $("#ddlSeriesOptions option[value='0']").attr("disabled", 'disabled');
                $("#ddlSeriesOptions option[value='1']").attr("disabled", 'disabled');

                if (!$("#ddlSeriesOptions option[value='2']").attr("selected"))
                    $("#ddlSeriesOptions option[value='2']").attr('selected', 'selected');
            } else if (seriesType == seriesTypes.SOLIDGAUGE) {
                $("#ddlSeriesOptions option[value='0']").attr("disabled", 'disabled');

                if (!$("#ddlSeriesOptions option[value='1']").attr("selected") && !$("#ddlSeriesOptions option[value='2']").attr("selected"))
                    $("#ddlSeriesOptions option[value='1']").attr('selected', 'selected');

                $(".chartStyleAxisSettings").hide();
            }

            if (seriesType == seriesTypes.SCATTER || seriesType == seriesTypes.BUBBLE) {
                $("#chartstyle_series_marker_enabled").attr("checked", "checked");

                if (previousType && previousType != seriesTypes.SCATTER && previousType != seriesTypes.BUBBLE) {
                    $('#chartstyle_series_dataLabels_align').val('center');
                    $('#chartstyle_series_dataLabels_verticalAlign').val('middle');
                }
            }
            $('#chartstyle_series_marker_enabled').closest('tr').toggle(Storyboard.Constants.SeriesTypes.isLineOrAreaBased(seriesType));
            $(".hdTopValuesPerGroup").css("display", (seriesType == seriesTypes.SCATTER || seriesType == seriesTypes.BUBBLE || seriesType == seriesTypes.TREEMAP || seriesType == seriesTypes.MARIMEKKO) ? "none" : "");

            if (seriesType == seriesTypes.COLUMN || seriesType == seriesTypes.BAR || seriesType == seriesTypes.FUNNEL) {
                $('#divColumnBarStyles').show();
            } else {
                $('#divColumnBarStyles').hide();
            }

            if (seriesType == seriesTypes.PIE || seriesType == seriesTypes.DONUT) {
                $("#chartstyle_series_dataLabels_distance").parent().show();
            } else {
                $("#chartstyle_series_dataLabels_distance").parent().hide();
            }

            if (seriesTypes.hasHorizontalXAxis(seriesType))
                $("#chartstyle_xAxis_labels_staggerLines").closest("tr").show();
            else
                $("#chartstyle_xAxis_labels_staggerLines").closest("tr").hide();

            if (seriesType == seriesTypes.PIE || seriesType == seriesTypes.DONUT ||
                seriesType == seriesTypes.GAUGE || seriesType == seriesTypes.SOLIDGAUGE)
                $("#chartstyle_xAxis_labels_step").closest("tr").hide();
            else
                $("#chartstyle_xAxis_labels_step").closest("tr").show();

            if (seriesType == seriesTypes.SOLIDGAUGE) {
                if ($("#ddlLegendPosition option:selected").val() == 6)
                    HTMLHelpers.setSelectedValues("#ddlLegendPosition", 1);
                $("#ddlLegendPosition option[value=6]").attr("disabled", "disabled");
            } else
                $("#ddlLegendPosition option[value=6]").removeAttr("disabled");

            ChartSetupUI.adjustLabelPositionControls(seriesType);
            ChartSetupUI.showHideLabelPosition();
            ChartSetupUI.disablePosNeg();
            ChartSetupUI.disableSigTest(seriesType);
            ChartSetupUI.showHideTwoColorControls();
            ChartSetupUI.showHideDataLabelPadding();
            ChartSetupUI.disableRespCountTooltip();
        },
        adjustLabelPositionControls: function (seriesType) {
            var seriesTypes = Storyboard.Constants.SeriesTypes;
            if (seriesType == seriesTypes.SCATTER || seriesType == seriesTypes.BUBBLE) {
                $('#chartstyle_series_dataLabels_align option[value="right"]').text('Left');
                $('#chartstyle_series_dataLabels_align option[value="center"]').text('Center');
                $('#chartstyle_series_dataLabels_align option[value="left"]').text('Right');
            } else {
                $('#chartstyle_series_dataLabels_align option[value="right"]').text('Top');
                $('#chartstyle_series_dataLabels_align option[value="center"]').text('Middle');
                $('#chartstyle_series_dataLabels_align option[value="left"]').text('Bottom');
            }

            $('#verticalLabelPosition').toggle(seriesType == seriesTypes.SCATTER || seriesType == seriesTypes.BUBBLE);
        },
        disableForSeriesOptions: function (seriesOption) {
            $('#chartstyle_series_dataLabels_align').removeAttr("disabled");
            ChartSetupUI.showHideLabelPosition();
        },
        showHideLabelPosition: function () {
            var seriesType = $('#ddlSeriesType').val();
            var seriesOption = $('#ddlSeriesOptions').val();
            var seriesTypes = Storyboard.Constants.SeriesTypes;

            if (seriesType == seriesTypes.PIE || seriesType == seriesTypes.DONUT || seriesType == seriesTypes.MARIMEKKO ||
                seriesType == seriesTypes.HEATMAP || seriesType == seriesTypes.TREEMAP || parseInt(seriesOption) > 0)
                $('#chartstyle_series_dataLabels_align').parent().hide();
            else
                $('#chartstyle_series_dataLabels_align').parent().show();
        },
        addHFilterToComparison: function (hFilterComparison) {
            //object exists when bound
            if (!hFilterComparison) {
                var selectedRule = $("#hFilterComparisonRules :selected");
                var noOfLevels = selectedRule.val() == 0 ? 0 : $("#hFilterComparisonLevels").val();

                hFilterComparison = {
                    ruleId: selectedRule.val(),
                    ruleName: selectedRule.text(),
                    noOfLevels: noOfLevels
                };
            }
            else {
                hFilterComparison.ruleName = $("#hFilterComparisonRules option[value='" + hFilterComparison.ruleId + "']").text();
            }

            var newSelection = $("#hFilterSelectedComparisonGroups tr.prototype_hidden").clone();
            newSelection.removeClass("prototype_hidden");
            newSelection.find(".selection").append(hFilterComparison.ruleName);
            newSelection.find(".selection input[type='hidden']").val(hFilterComparison.ruleId);
            newSelection.find(".levels").text(hFilterComparison.noOfLevels);
            var cbId = 'cbApplyAR' + Helpers.generateGuid();
            newSelection.find('.chbApplyHFAccessRights').attr('id', cbId).attr('checked', hFilterComparison.applyAccessRights);
            newSelection.find('.lblApplyHFAccessRights').attr('for', cbId);
            if (hFilterComparison.ruleId == 4)
                newSelection.find('.divHFRuleAccessRights').hide();

            if (hFilterComparison.ruleId !== 0 || $("#hFilterSelectedComparisonGroups .selection input[type='hidden'][value='0']").length === 0) {
                $("#hFilterSelectedComparisonGroups tr:last").after(newSelection);
                $("#hFilterSelectedComparisonGroups tr:last button.delete").bind("click", function () { ChartSetupUI.removeHFiltercomparison(this); });
            }

            var color;
            if (hFilterComparison.color || hFilterComparison.color === 0) {
                color = Helpers.convertFromDecimalToHex(hFilterComparison.color);
            } else if ($.fn.DUIColorPicker.useNewColorTemplateLogic) {
                var standardPaletteCategory = $.fn.DUIColorPicker.find.standardPaletteCategory();
                var standardPaletteColor = standardPaletteCategory.colors[0];
                color = tinycolor(standardPaletteColor).toRgbString();
            } else
                color = '#000000';

            newSelection.find('.txtHFRuleColorPreview').DUIColorPicker({
                layout: 'template',
                transparent: false,
                selected: {
                    colorString: color,
                    templateColorId: hFilterComparison.color_colorPlaceholderId
                }
            });

            ChartSetupUI.addHFilterToGrouping(true);
        },
        removeHFiltercomparison: function (sender) {
            $(sender).parents("tr").remove();

            var hasComparisons = $("#hFilterSelectedComparisonGroups tr td.selection").length > 1;

            if (!hasComparisons)
                ChartSetupUI.addHFilterToGrouping(hasComparisons);
        },
        clearHFilterComparison: function () {
            var removeableElements = $("#hFilterSelectedComparisonGroups tr.prototype_hidden").nextAll();
            if (removeableElements)
                removeableElements.remove();
        },
        comparisonGroupChanged: function () {
            var changedElement = $("#hFilterComparisonRules");
            var noOfLevels = $("#hFilterComparisonLevels");
            //top group === 0

            switch (changedElement.val()) {
                case "0":
                case "4":
                case "5":
                case "6":
                    noOfLevels.val("0");
                    noOfLevels.attr("disabled", true);
                    break;
                default:
                    noOfLevels.attr("disabled", false);
                    break;
            }
        },
        addSeriesColorStop: function (dynamicColorStopTemplate, lastColorStop) {
            var index = lastColorStop ? parseInt(lastColorStop.attr('data-index')) + 1 : 0;

            var $dynamicColorStop = dynamicColorStopTemplate.clone();
            $dynamicColorStop
                .attr('id', 'dynamicColorStop_' + index)
                .attr('data-index', index);

            $dynamicColorStop.find('#dynamicColorPreview').attr('id', 'dynamicColorPreview_' + index);

            $dynamicColorStop.find('#dynamicColorStopValue').attr('id', 'dynamicColorStopValue_' + index)
            $dynamicColorStop.find('#dynamicColorStopValuePercent').attr('id', 'dynamicColorStopValuePercent_' + index)
            if ($('#ddlGradientType').val() == Storyboard.Constants.GradientTypes.DynamicScale) {
                $dynamicColorStop.find('#dynamicColorStopValuePercent_' + index).show();
                Helpers.setupNumericTextbox($dynamicColorStop.find('#dynamicColorStopValue_' + index), { minValue: 0, maxValue: 100 });
            } else {
                $dynamicColorStop.find('#dynamicColorStopValuePercent_' + index).hide();
                Helpers.setupNumericTextbox($dynamicColorStop.find('#dynamicColorStopValue_' + index));
            }

            if (index > 1) {
                $dynamicColorStop.find('#btnDeleteDynamicColorStop')
                    .attr('id', 'btnDeleteDynamicColorStop_' + index)
                    .bind("click", function () { $dynamicColorStop.remove(); });
            } else {
                $dynamicColorStop.find('#btnDeleteDynamicColorStop').remove();
            }

            $dynamicColorStop.css('display', '');

            if (lastColorStop)
                lastColorStop.after($dynamicColorStop);
            else
                dynamicColorStopTemplate.after($dynamicColorStop);

            return index;
        },
        showHideColorPickerForSeries: function () {
            var colorSources = Storyboard.Constants.ColorSources;

            var seriesColorSource = HTMLHelpers.getSelectValue('#ddlColorLogic');

            $('#seriesColorPickerDiv, #seriesColorTemplateDiv, #dynamicColorsDiv').hide();
            $('#hdChartSettings').css('overflow', '');

            if (seriesColorSource.value == colorSources.COLOR_TEMPLATE && $.fn.DUIColorPicker.useNewColorTemplateLogic) {
                $('#seriesColorTemplateDiv').show();
                $('#seriesColorCategory').DUIColorSelect({layout: 'category', allCategories: false, standardPalette: true});
                $('#hdChartSettings').css('overflow', 'visible');
            }

            if (seriesColorSource.value == colorSources.SINGLE_COLOR) {
                $('#seriesColorPickerDiv').show();
            }

            if (seriesColorSource.value == colorSources.DYNAMIC_COLORS || $("#chbUseTableCellGradient").is(":checked")) {
                $('#dynamicColorsDiv').show();
            }
        },
        showHideColorPickerForSeriesScatter: function () {
            var colorSources = Storyboard.Constants.ColorSourcesScatter;

            var seriesColorSource = HTMLHelpers.getSelectValue('#ddlColorSource');

            $('#seriesColorPickerDivScatter, #seriesColorTemplateDivScatter').hide();

            if (seriesColorSource.value == colorSources.ColourTemplate && $.fn.DUIColorPicker.useNewColorTemplateLogic) {
                $('#seriesColorTemplateDivScatter').show();
                $('#seriesColorCategoryScatter').DUIColorSelect({ layout: 'category', allCategories: false, standardPalette: true });
            }

            if (seriesColorSource.value == colorSources.SingleColor) {
                $('#seriesColorPickerDivScatter').show();
            }
        },
        showHideLegendPosition: function () {
            var seriesType = $('#ddlSeriesType').val();
            var st = Storyboard.Constants.SeriesTypes;

            $('.hdLegendPos').hide();

            if (ChartSetupDataBinding.GetBoundDataGroup().isMain) {
                $('.hdLegendPos').show();

                if ((seriesType == st.TREEMAP || seriesType == st.HEATMAP)
                    && $('#ddlColorLogic').val() != Storyboard.Constants.ColorSources.DYNAMIC_COLORS)
                    $('.hdLegendPos').hide();
            }
        },
        hideHFilterPanel: function (showHFilter) {
            if (showHFilter) {
                $("#hFilterSettingPanel").css("display", "");
                $("#fsHFilters").css("display", "");
                $("#optHFilterContainer").css("display", "");
            }
            else {
                $("#hFilterSettingPanel").css("display", "none");
                $("#fsHFilters").css("display", "none");
                $("#optHFilterContainer").css("display", "none");
            }

            $('#hFilterSettingPanel').attr("hasData", Boolean(showHFilter));
        },
        disableSigTests: function () {
            var enabled = $("#chkSignificance").attr("checked");
            if (enabled) {
                $(".sigOptions").removeAttr("disabled").removeClass('hidden');
            }
            else {
                $(".sigOptions").attr("disabled", "disabled").addClass('hidden');
                $(".sigOptions").closest(".hdStatistics").removeClass('collapsable expandable').addClass('expandable');
            }
        },
        disableHideLowBase: function () {
            var enabled = $("#chbTrimLowBase").attr("checked");

            if (enabled) {
                $("#chbTrimLowBase").siblings("input").removeAttr("disabled");
                $(".hideLowBaseContainer").removeAttr("disabled").css('display', 'block');
                if ($('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.TREEMAP)
                    $('#ddlTrimType').closest('.settingItem').hide();
                else
                    $('#ddlTrimType').closest('.settingItem').show();
            }
            else {
                $("#chbTrimLowBase").siblings("input").attr("disabled", "disabled");
                $(".hideLowBaseContainer").attr("disabled", "disabled").css('display', 'none');
            }

            ChartSetupUI.showHideSubseriesLowBase();
        },
        showHideSubseriesLowBase: function () {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            if (dataGroup.isMain) {
                $('#chbTrimLowBase').closest('.settingItem').show();
            } else {
                var applyMainSettings = $('#chbTrimLowBaseByMain').attr('checked');
                $('.hideLowBaseContainer').toggle(!applyMainSettings);
                $('#chbTrimLowBase').closest('.settingItem').toggle(!applyMainSettings);
            }
        },
        disableHideLowResult: function () {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var applyMainSettings = !dataGroup.isMain && $('#chbTrimLowResultByMain').attr('checked');
            var enabled = $("#chbTrimLowResult").attr("checked");
            if (enabled && !applyMainSettings) {
                $("#ddlTrimLowResultObject, #txtTrimLowResultValue").removeAttr("disabled");
                $(".trimLowResult").removeAttr("disabled").css('display', 'block');
                if ($('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.TREEMAP)
                    $('#ddlTrimLowResultType').closest('.settingItem').hide();
                else
                    $('#ddlTrimLowResultType').closest('.settingItem').show();
                ChartSetupUI.disableHideLowResultBaseType();
            }
            else {
                $("#ddlTrimLowResultObject, #txtTrimLowResultValue").attr("disabled", "disabled");
                $(".trimLowResult").attr("disabled", "disabled").css('display', 'none');
            }
        },
        showHideSubseriesLowResult: function () {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var applyMainSettings = !dataGroup.isMain && $('#chbTrimLowResultByMain').attr('checked');
            $('.trimLowResult').toggle(!applyMainSettings);
            $('.hideLowResultContainer > .settingsTable').toggle(!applyMainSettings);
        },
        disableHideLowResultBaseType: function () {
            var hideResult = $("#ddlTrimLowResultObject").val();
            $("#ddlTrimLowResultUseWeight").closest(".trimLowResult").toggle(hideResult == 2);
        },
        toggleCustomWarnLimit: function () {
            var isCustom = $("#ddlWarnLimits").val() == 0;
            $('#txtWarnLowBase').toggle(isCustom);
            Helpers.setupNumericTextbox($("#txtWarnLowBase"));
        },
        toggleCustomHideLimit: function () {
            var isCustom = $("#ddlHideLimits").val() == 0;
            $('#txtTrimLowBase').toggle(isCustom);
            Helpers.setupNumericTextbox($("#txtTrimLowBase"));

        },
        disableColumnWidth: function (sender) {
            $('#rt_cell_width').parent().css('visibility', !sender.checked ? 'hidden' : '');
        },
        disableRowHeight: function (sender) {
            $('#rt_cell_height').parent().css('visibility', !sender.checked ? 'hidden' : '');
        },
        disableWarnLowBase: function () {
            var enabled = $("#chbWarnLowBase").attr("checked");

            if (enabled) {
                $("#chbWarnLowBase").siblings("select, input").removeAttr("disabled");
                $(".warnLowBaseContainer").removeAttr("disabled").css('display', 'block');
            }
            else {
                $("#chbWarnLowBase").siblings("select, input").attr("disabled", "disabled");
                $(".warnLowBaseContainer").attr("disabled", "disabled").css('display', 'none');
            }

            ChartSetupUI.showHideSubseriesWarnLowBase();
        },
        showHideSubseriesWarnLowBase: function () {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            if (dataGroup.isMain) {
                $('#chbWarnLowBase').closest('.settingItem').show();
            } else {
                var applyMainSettings = !dataGroup.isMain && $('#chbWarnLowBaseByMain').attr('checked');
                $('.warnLowBaseContainer').toggle(!applyMainSettings);
                $('#chbWarnLowBase').closest('.settingItem').toggle(!applyMainSettings);
            }
        },
        showHideThresholdSettings: function () {
            var enabled = $("#chbThreshold").attr("checked");

            if (enabled) {
                $('.thresholdSettings').css("display", "");
                $('#chkPercentile').removeAttr('checked');
                $('#chkPercentile').attr('disabled', 'disabled');
            }
            else {
                $('.thresholdSettings').css("display", "none");
                $('#chkPercentile').removeAttr('disabled');
            }
        },
        showHideTwoColorControls: function () {
            var seriesType = parseInt($("#ddlSeriesType").val(), 10);
            var seriesOption = parseInt($('#ddlSeriesOptions').val(), 10);
            if (Storyboard.Constants.SeriesTypes.canUseTwoColorLogic(seriesType, seriesOption)) {
                $("#chbUseTwoColorLogic").closest("tr").show();
                if ($("#chbUseTwoColorLogic").attr("checked")) {
                    $(".seriesLabelsTwoColor").show();
                    $(".seriesLabelsOneColor").hide();
                } else {
                    $(".seriesLabelsTwoColor").hide();
                    $(".seriesLabelsOneColor").show();
                }
            } else {
                $("#chbUseTwoColorLogic").attr("checked", false);
                $("#chbUseTwoColorLogic").closest("tr").hide();
                $(".seriesLabelsTwoColor").hide();
                $(".seriesLabelsOneColor").show();
            }
        },
        disableWeightVariable: function (sender) {
            var chbShowWeightBase = $("#chbShowWeightedBase");
            var chbShowNonWeightBase = $("#chbShowNonWeightedBase");
            var ddlShowBase = $("#ddlShowBase");
            var ddlTrimLow = $("#ddlTrimLowBase");
            var ddlWarnLow = $("#ddlWarnLowBase");
            var ddlTrimLowResult = $("#ddlTrimLowResultUseWeight");
            var ddlSigTestLimit = $("#ddlSigTestLimitBase");
            var weighted = 1, nonweighted = 2, effective = 5;

            if (sender.checked) {
                $('#ddlWeight').removeAttr('disabled');
                chbShowWeightBase.parent().children().removeAttr('disabled');
                ddlShowBase.find("option[value='" + weighted + "']").removeAttr('disabled');
                ddlTrimLow.find("option[value='" + weighted + "']").removeAttr('disabled');
                ddlWarnLow.find("option[value='" + weighted + "']").removeAttr('disabled');
                ddlTrimLowResult.find("option[value='" + weighted + "']").removeAttr('disabled');
                ddlSigTestLimit.find("option[value='" + weighted + "'], option[value='" + effective + "']").removeAttr('disabled');
            }
            else {
                $('#ddlWeight').attr('disabled', 'disabled');
                chbShowWeightBase.parent().children().attr("disabled", "disabled");
                ddlShowBase.find("option[value='" + weighted + "']").attr("disabled", "disabled");
                ddlTrimLow.find("option[value='" + weighted + "']").attr("disabled", "disabled");
                ddlWarnLow.find("option[value='" + weighted + "']").attr("disabled", "disabled");
                ddlTrimLowResult.find("option[value='" + weighted + "']").attr("disabled", "disabled");
                ddlSigTestLimit.find("option[value='" + weighted + "'], option[value='" + effective + "']").attr("disabled", "disabled");

                if (parseInt(ddlShowBase.val(), 10) === weighted)
                    ddlShowBase.val(nonweighted);

                if (parseInt(ddlTrimLow.val(), 10) === weighted)
                    ddlTrimLow.val(nonweighted);

                if (parseInt(ddlWarnLow.val(), 10) === weighted)
                    ddlWarnLow.val(nonweighted);

                if (parseInt(ddlTrimLowResult.val(), 10) === weighted)
                    ddlTrimLowResult.val(nonweighted);

                if (parseInt(ddlSigTestLimit.val(), 10) === weighted || parseInt(ddlSigTestLimit.val(), 10) === effective) 
                    ddlSigTestLimit.val(nonweighted);

                if (chbShowWeightBase.attr("checked")) {
                    chbShowWeightBase.removeAttr("checked");
                    chbShowNonWeightBase.attr("checked", true);
                }
            }
        },
        addNewTargetArea: function () {
            var taTableId = "targetAreasTable", taRowTemplateClass = "targetAreaTemplate";
            var newRow = ChartSetupUI.addRowFromTemplate(taTableId, taRowTemplateClass, { layout: 'template' });

            newRow.find("#btnDeleteTargetArea").bind("click", function () {
                ChartSetupUI.removeRow(this, "targetAreaRow");
            });
        },
        addValueBasedColor: function (ValueBasedColorsTemplate, lastColorStop) {
            var index = lastColorStop ? parseInt(lastColorStop.attr('data-index')) + 1 : 0;

            var $valueBasedColor = ValueBasedColorsTemplate.clone();
            $valueBasedColor
                .attr('id', 'valueBasedColor_' + index)
                .attr('data-index', index);

            $valueBasedColor.find('#ValueBasedColorsPreview').attr('id', 'ValueBasedColorsPreview_' + index);

            $valueBasedColor.find('#valueBasedStartValue').attr('id', 'valueBasedStartValue_' + index)
            $valueBasedColor.find('#valueBasedStopValue').attr('id', 'valueBasedStopValue_' + index)
            $valueBasedColor.find('#valueBasedStartCondition').attr('id', 'valueBasedStartCondition_' + index)
            $valueBasedColor.find('#valueBasedStopCondition').attr('id', 'valueBasedStopCondition_' + index)

            if (index > 0) {
                $valueBasedColor.find('#btnDeleteValueBaseColoring')
                    .attr('id', 'btnDeleteValueBaseColoring_' + index)
                    .bind("click", function () { $valueBasedColor.remove(); });
            } else {
                $valueBasedColor.find('#btnDeleteValueBaseColoring').remove();
            }


            $valueBasedColor.css('display', '');

            if (lastColorStop)
                lastColorStop.after($valueBasedColor);
            else
                ValueBasedColorsTemplate.after($valueBasedColor);

            Helpers.setupNumericTextbox('#valueBasedStartValue_' + index);
            Helpers.setupNumericTextbox('#valueBasedStopValue_' + index);

            return index;

        },
        addNewGradientStop: function () {
            var tableId = "tblHeatMapGradient", rowTemplateClass = "heatmapGradientTemplate", deleteBtnId = "btnDeleteGradientStop";
            var newRow = ChartSetupUI.addRowFromTemplate(tableId, rowTemplateClass);

            newRow.find("#" + deleteBtnId).bind("click", function () {
                ChartSetupUI.removeRow(this, 'heatmapGradientRow');
            });
        },
        addRowFromTemplate: function (tableId, rowTemplateClass, colorPickerSettings) {
            var template = $("." + rowTemplateClass);
            template.show();

            var newRow = template.clone();
            newRow.removeClass(rowTemplateClass);

            var colorTxt = newRow.find(".ColorTextboxTemplate");
            colorTxt.addClass("ColorTextbox").removeClass("ColorTextboxTemplate");
            $("#" + tableId + " > tbody:last").append(newRow);

            template.hide();
            $("#" + tableId).find(".ColorTextbox").DUIcolorPicker(colorPickerSettings);

            return newRow;
        },
        removeRow: function (sender, rowClass) {
            $(sender).closest('.' + rowClass).remove();
        },
        disableCustomRadius: function () {
            if ($("#chbAutoRadius").attr("checked"))
                $("#txtCustomRadius").attr("disabled", "disabled");
            else
                $("#txtCustomRadius").removeAttr("disabled");
        },
        disableCustomGradient: function () {
            if ($("#chbAutoGradient").attr("checked"))
                $("#divCustomGradientSettings").hide();
            else
                $("#divCustomGradientSettings").show();
        },
        disableMeanSeries: function () {
            if ($("#chbEnableMeanValueSeries").attr("checked")) {
                $(".hdMeanValueSeries input, .hdMeanValueSeries select").removeAttr("disabled");
                ChartSetupUI.disableRunTopAfterMeanAggregate();
            }
            else
                $(".hdMeanValueSeries input[id!='chbEnableMeanValueSeries'], .hdMeanValueSeries select").attr("disabled", true);
        },
        disableMeanSeriesPosition: function () {
            if ($("#chbHideOriginalSeries").attr("checked"))
                $(".sMeanSeriesPosition").hide();
            else
                $(".sMeanSeriesPosition").show();
        },
        disableMeanSeriesColor: function () {
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            if ($("#ddlMeanValueOrientation").val() === "1"
                || $("#ddlMeanSeriesSubgroup").val() != 0
                || $('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.HEATMAP
                || contentType == Storyboard.Constants.itemTypes.SIMPLETABLE)
                $(".sMeanSeriesColor").hide();
            else
                $(".sMeanSeriesColor").show();
        },
        disableMeanSeriesSubgroup: function () {
            if ($("#ddlMeanValueOrientation").val() === "1")
                $(".sMeanSeriesSubgroup").hide();
            else
                $(".sMeanSeriesSubgroup").show();
        },
        disableRunTopAfterMeanAggregate: function () {
            var meanOrAggregateOn = $("#chbEnableMeanValueSeries").attr("checked") || $("#chbEnableAggregatedSeries").attr("checked");
            if (meanOrAggregateOn && $("#chbShowTopValuesPerGroup").attr("checked"))
                $(".sRunTopAfterMeanAggregate").show();
            else
                $(".sRunTopAfterMeanAggregate").hide();
        },
        hideOptionalFilters: function () {
            var checked = $("#chbUseMainOptFilterSettings").attr("checked");
            $("#divSetupOptFilters").css('display', checked ? 'none' : 'block');
        },
        enableValuesPerGroup: function () {
            var checked = $("#chbShowTopValuesPerGroup").attr("checked");

            if (checked) {
                $("#ddlShowTopValuesPerGroupOrientation").removeAttr("disabled");
                $("#txtShowTopValuesPerGroup").removeAttr("disabled");
                Helpers.setupNumericTextbox($("#txtShowTopValuesPerGroup"));
                $("#tblShowTopValuePerGroupNames input").removeAttr("disabled");
                $("#ddlTopValuesSubgroups").removeAttr("disabled");
            } else {
                $("#ddlShowTopValuesPerGroupOrientation").attr("disabled", true);
                $("#txtShowTopValuesPerGroup").attr("disabled", true);
                $("#tblShowTopValuePerGroupNames input").attr("disabled", true);
                $("#ddlTopValuesSubgroups").attr("disabled", true);
            }
        },
        updateRankingObjects: function (selectedRankObject) {
            var axis = parseInt($("#ddlRankingAxis").val(), 10);
            selectedRankObject = selectedRankObject ? selectedRankObject : $("#ddlRankObject").val();
            ChartSetupUI.bindAxisLegendItemsToDdl('#ddlRankObject', selectedRankObject, axis, locale.get('All items'), -1);
        },
        updateRankingOptionalFilters: function (selectedItem) {
            selectedItem = selectedItem ? selectedItem : $("#ddlRankOptionalFilter").val();
            $("#ddlRankOptionalFilter option").removeAttr("selected");

            HTMLHelpers.optionToComment($("#ddlRankOptionalFilter option"));
            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlRankOptionalFilter'), '[value="0"]'));
            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlRankOptionalFilter'), '[value="varsubset"]')); 

            $.map($('#lbLegendList > li, #lbAxisList > li'), function (e) {
                if ($(e).attr('data-value') === 'filter') {
                    $(e).find('li').map(function (i, f) {
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlRankOptionalFilter"), "option[value='" + $(f).attr('data-value') + "']"));
                    });
                } else
                    HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlRankOptionalFilter"), "option[value='" + $(e).attr('data-value') + "']"));
            });

            $("#ddlRankOptionalFilter > option[value='" + selectedItem + "']").attr("selected", true);
        },
        enableRanking: function () {
            var enable = $("#chkEnableRanking").attr("checked");
            $(".fsRanking").css('display', enable ? '' : 'none');
        },
        enableRankingOptionalFilter: function () {
            var enable = $("#chkRankOnOptionalFilter").attr("checked");
            $(".rankOptionalFilter").css('display', enable ? '' : 'none');
        },
        enableRankingPosition: function () {
            var enable = !$("#chkShowOnlyRanking").attr("checked");
            $(".rankPosition").css('display', enable ? '' : 'none');
        },
        enableRankingSuffix: function () {
            var enable = $('#chkShowRankTotalSuffix').attr('checked');
            $('.rankTotalSuffix').css('display', enable ? '' : 'none');
        },
        checkHideOriginal: function (check) {
            $('#chbHideOriginalSeries, #chbAggrHideOriginalSeries').attr('checked', check);

            ChartSetupUI.disableMeanSeriesPosition();
            ChartSetupUI.disableAggregatedSeriesPosition();
        },
        enableCustomHeaders: function () {
            // column
            $(".fsCustomColumnHeaders").css('display', $("#chkEnableCustomColumnHeaders").attr("checked") ? '' : 'none');
            // row
            $(".fsCustomRowHeaders").css('display', $("#chkEnableCustomRowHeaders").attr("checked") ? '' : 'none');
        },
        addNewCustomHeader: function (axis) {
            var tableId = axis == 1 ? "tblCustomRowHeaders" : "tblCustomColumnHeaders", rowTemplateClass = "customHeaderTemplate";
            var newRow = ChartSetupUI.addRowFromTemplate(tableId, rowTemplateClass, { layout: 'template' });

            newRow.find("#btnDeleteCustomHeader").bind("click", function () {
                ChartSetupUI.removeRow(this, "customHeaderRow");
            });
        },
        makeCollapsable: function () {
            $('#setupChart').delegate('fieldset.expandable', 'click', function (e) {
                e.stopPropagation();
                var collapseGroup = $(this).attr('data-collapse-group');
                if (collapseGroup !== undefined) {
                    $(collapseGroup).find('fieldset.collapsable').removeClass('collapsable').addClass('expandable');
                }

                $(this).removeClass('expandable').addClass('collapsable');
            });

            $('#setupChart').delegate('fieldset.collapsable > .advanced', 'click', function (e) {
                e.stopPropagation();
                $(this).parent().removeClass('collapsable').addClass('expandable');
            });
        },
        hideBasePosition: function () {
            var contentType = ChartSetupDataBinding.GetBoundContentType();

            if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
                $(".tableBaseSize").toggle($("#ddlShowBase").val() !== "0");
            }
        },
        updateBaseOrientation: function () {
            var columns = $("#ddlTableBasePosition").val() === "3";
            $('#ddlTableBaseOrientation option[value=1]').text(columns ? "Left" : "Top");
            $('#ddlTableBaseOrientation option[value=2]').text(columns ? "Right" : "Bottom");
        },
        updateThumbnail: function (iconShape) {
            $(".sigTestIconInEdit").find(".sigTestIconId").val(iconShape.iconShapeId);
            $(".sigTestIconInEdit").find(".iconPreviewEl").html(IconShapeUI.fixGUIDs(iconShape.content)).css('display', 'block');
            IconShapeUI.updateIconShapeElementSize(null, $(".sigTestIconInEdit").find(".iconPreviewEl"));
        },
        showSigTestHelp: function () {
            var html =
                "<div>" +
                "<div style=\"font-size:14px\">Option A</div><br />" +
                "<div>The yellow parts of the formula shown below will be based on unweighted numbers.</div><br />" +
                "<div><img src=\"../storyboard/images/sigtestmean_A.png\"/></div>OR" +
                "<div><img src=\"../storyboard/images/sigtestproportion_A.png\"/></div><br />" +
                "<div style=\"font-size:14px\">Option B</div><br />" +
                "<div>The yellow parts of the formula shown below will be based on unweighted numbers.</div><br />" +
                "<div><img src=\"../storyboard/images/sigtestmean_B.png\"/></div>OR" +
                "<div><img src=\"../storyboard/images/sigtestproportion_B.png\"/></div>" +
                "</div>";

            new DUIwindow2({
                title: "",
                width: 510,
                padding: 45,
                buttonsHeight: 50,
                buttons: [],
                html: html,
                modal: true,
                preWrapSpace: false
            });
        },
        showTextMatchLogicHelp: function () {
            new DUIwindow2({
                title: "",
                width: 600,
                padding: 45,
                buttonsHeight: 50,
                buttons: [],
                html: "<div><img src=\"../storyboard/images/sigtest_TextMatchLogic.png\"/></div>",
                modal: true,
                preWrapSpace: false
            });
        },
        showSeriesLayoutInfo: function(){
            var html =
                "<div>" +
                '<h1>Series Layout</h1>' +
                '<h2>Slice And Dice</h2>' +
                '<p>Simple and fast layout algorithm. The drawback with the Slice And Dice is that series can get different aspect ratios which makes it hard to compare result.</p>' +
                '<h2>Stripes</h2>' +
                '<p>Also a simple and fast layout algorithm which is quite similar to Slice And Dice but instead of alternating the direction between each series, it draws all series in same direction, creating a set of columns.</p>' +
                '<h2>Squarified</h2>' +
                '<p>A layout algorithm which aims to give each series a low aspect ratio for a better visual comparison. It adds the series one by one to a strip until it finds the best aspect ratio available. Then it alternates the direction and does the same with a new strip. The process continues in the same pattern until all series are placed in the chart.</p>' +
                '<h2>Strip</h2>' +
                '<p>The Strip algorithm has the same objective as the Squarified algorithm, to get low aspect ratios. The process is quite similar, but instead of alternating the direction, the strips are drawn side by side as columns.</p>' +
                "</div>";

            new DUIwindow2({
                title: "",
                width: 510,
                padding: 45,
                buttonsHeight: 50,
                buttons: [],
                html: html,
                modal: true,
                preWrapSpace: false
            });
        },
        showGradientTypeInfo: function(){
            var html =
                "<div>" +
                '<div>' +
                '<h1>Gradient Type</h1>' +
                '<h2>Fixed scale</h2>' +
                '<p>The colors applied will be generated using the defined min and max scale. The scale displayed will also use these values.  Use the actual values as the inputs when defining the colors.</p>' +
                '<h2>Dynamic scale</h2>' +
                '<p>The scale and colors will be mapped against the lowest and highest value in the Heatmap. The percentage values are based on the lowest and highest values in the results.</p>' +
                '</div>' +
                '<div>' +
                '<p><em>** We recommend always using fixed scale when the results will be compared against other charts.</em><p' +
                '</div>' +
                "</div>";

            new DUIwindow2({
                title: "",
                width: 510,
                padding: 45,
                buttonsHeight: 50,
                buttons: [],
                html: html,
                modal: true,
                preWrapSpace: false
            });
        },
        showHideDataLabelPadding: function () {
            var seriesType = $("#ddlSeriesType").val(),
                seriesOption = $("#ddlSeriesOptions").val(),
                seriesTypes = Storyboard.Constants.SeriesTypes,
                seriesOptions = Storyboard.Constants.SeriesOptions,
                shouldHideDataLabelPadding = false;

            if (seriesType == seriesTypes.MARIMEKKO || ((seriesTypes.BAR || seriesType == seriesTypes.COLUMN) && (seriesOption == seriesOptions.Stacked || seriesOption == seriesOptions.FullStacked))) {

                shouldHideDataLabelPadding = true;
            }

            $("#chartstyle_series_dataLabels_padding").closest("tr").css("display", shouldHideDataLabelPadding ? "none" : "");
        },
        showHideExcelExportAllRows: function () {
            // it's a table, object export to excel is enabled and table is showing X rows/columns
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            var show = contentType == Storyboard.Constants.itemTypes.SIMPLETABLE &&
                $("#chbAllowExcelExport").is(":checked") && $("#chbShowTopSeries").is(":checked");
            $(".objectExcelExportAllRows").css("display", show ? "" : "none");
        },
        disableAggregatedSeries: function () {
            if ($("#chbEnableAggregatedSeries").attr("checked")) {
                $(".hdAggregatedSeries input, .hdAggregatedSeries select").removeAttr("disabled");
                ChartSetupUI.disableRunTopAfterMeanAggregate();
            }
            else
                $(".hdAggregatedSeries input[id!='chbEnableAggregatedSeries'], .hdAggregatedSeries select").attr("disabled", true);
        },
        disableAggregatedSeriesPosition: function () {
            if ($("#chbAggrHideOriginalSeries").attr("checked"))
                $(".sAggregatedSeriesPosition").hide();
            else
                $(".sAggregatedSeriesPosition").show();
        },
        disableAggregatedSeriesColor: function () {
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE || $("#ddlAggrSeriesOrientation").val() === "1" ||
                $("#ddlAggregatedSeriesSubgroup").val() != 0 || $('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.HEATMAP) // Axis, or subgroup is used
                $(".sAggregatedSeriesColor").hide();
            else
                $(".sAggregatedSeriesColor").show();
        },
        disableAggregatedSeriesSubgroup: function () {
            if ($("#ddlAggrSeriesOrientation").val() === "1")
                $(".sAggregatedSeriesSubgroup").hide();
            else
                $(".sAggregatedSeriesSubgroup").show();
        },
        disableRunAggregatedSeriesBeforeTop: function () {
            if ($("#chbEnableAggregatedSeries").attr("checked") && $("#chbShowTopValuesPerGroup").attr("checked"))
                $(".sAggregatedSeriesRunBeforeTopByValue").show();
            else
                $(".sAggregatedSeriesRunBeforeTopByValue").hide();
        },
        onPercentileChecked: function () {
            if ($('#chkPercentile').attr('checked')) {
                $("#ddlSeriesOptions option[value='2']").attr("disabled", 'disabled');
                $("#ddlSeriesOptions option[value='1']").attr('selected', 'selected');
                $('#chbThreshold').removeAttr('checked');
                $('#chbThreshold').attr('disabled', 'disabled');
            }
            else {
                $("#ddlSeriesOptions option[value='2']").removeAttr("disabled");
                $('#chbThreshold').removeAttr('disabled');
            }
        },
        showHideRefDataPanel: function () {
            $('.hdReferenceData').toggle(ProjectHasRefData && $('#ddlCalculationType').val() != 11);
        },
        disableRefData: function () {
            var disable = $('#chkPercentile').attr('checked') || $('#chkSignificance').attr('checked') ||
                $('#chkEnableBenchmark').attr('checked') || $('#chbEnableAggregatedSeries').attr('checked');
            if (disable)
                $('#chbEnableReferenceData').attr('disabled', 'disabled');
            else
                $('#chbEnableReferenceData').removeAttr('disabled');
        },
        onRefDataEnabled: function () {
            var enabled = ProjectHasRefData && $('#chbEnableReferenceData').attr('checked');
            if (enabled)
                $('#chkSignificance, #chkEnableBenchmark, #chkPercentile, #chbEnableAggregatedSeries').attr('disabled', 'disabled');
            else
                $('#chkSignificance, #chkEnableBenchmark, #chkPercentile, #chbEnableAggregatedSeries').removeAttr('disabled');

            ChartSetupUI.showHideRefDataSettings();
        },
        showHideRefDataSettings: function () {
            $('#fsRefDataSettings').toggle($('#chbEnableReferenceData').attr('checked'));
        },
        onRefDataResultTypeChanged: function (resultType) {
            $('input.refDataResult[value!="' + resultType + '"]').removeAttr('checked');

            $('.settingItem.sortOnRefData').toggle(resultType == 1);
            ChartSetupUI.onRefDataSortChanged();
            $('#txtRefDataPercentile').closest('.settingItem').toggle(resultType > 0 && resultType < 4 && ProjectHasPercentileRefData);

            var contentType = ChartSetupDataBinding.GetBoundContentType();
            $('#ddlRefDataPlacement').closest('.settingItem').toggle(contentType == Storyboard.Constants.itemTypes.SIMPLETABLE && resultType == 2);
        },
        onRefDataSortChanged: function () {
            var resultType = $('#fsRefDataSettings input.refDataResult:checked').val() || 0;
            var sortEnabled = $('#chbSortOnRefData').attr('checked');
            $('.settingItem.sortOnRefDataSettings').toggle(resultType == 1 && sortEnabled);
        },
        enableDisableTopSeriesSettings: function () {
            if ($('#chbShowTopSeries').attr('checked'))
                $('#ddlShowTopSeriesOrientation, #txtShowTopSeries, #ddlShowTopSeriesMode, #txtShowTopSeriesTo, #ddlRunTopSeriesAfterOp').removeAttr('disabled');
            else
                $('#ddlShowTopSeriesOrientation, #txtShowTopSeries, #ddlShowTopSeriesMode, #txtShowTopSeriesTo, #ddlRunTopSeriesAfterOp').attr('disabled', 'disabled');
            ChartSetupUI.showHideBeforeAfterTopSeries();
        },
        showHideBeforeAfterTopSeries: function () {
            var isEnabled = $('#chbShowTopSeries').attr('checked');
            var orientation = $('#ddlShowTopSeriesMode').val();
            var bmOrientation = $('#chkEnableBenchmark').attr('checked') ? $('#ddlBenchmarkAxis').val() : 0;
            var rankOrientation = $('#chkEnableRanking').attr('checked') ? $('#ddlRankingAxis').val() : 0;

            var bmMatched = (orientation == 1 && bmOrientation == 2) || (orientation == 2 && bmOrientation == 1);
            var rankMatched = (orientation == 1 && rankOrientation == 2) || (orientation == 2 && rankOrientation == 1);
            $('#ddlRunTopSeriesAfterOp').closest('.settingItem').toggle(isEnabled && (rankMatched || bmMatched));
        },
        showHideScatterMeanLineSettings: function () {
            $('#tblScatterMeanLineStyle').toggle($('#chbScatterMeanLines').attr('checked'));
        },
        showHideScatterMeanQuadrantSettings: function () {
            $('#tblScatterMeanQuadrantColors').toggle($('#chbScatterMeanQuadrants').attr('checked'));
        },
        showHideShortTextTypeSettings: function () {
            $('#scatterShortTextType').toggle($("input[name='scatterLabelPos']:checked").val() == 3);
            ChartSetupUI.showHideShortTextInputs();
        },
        showHideShortTextInputs: function () {
            var show = $("input[name='scatterLabelPos']:checked").val() == 3 && $('#ddlScatterShortTextType').val() == 1;
            $('#scatterLabelReplaceWin').css('margin-left', show ? '20%' : '0');
            $('.scatterShortText').toggle(show);
        },
        showHideTopSeriesRangeOptions: function () {
            $('.topBottomRangeSetting').toggle($('#ddlShowTopSeriesOrientation').val() == 3);
        },
        bindChartStylesSelectElements: function() {
            var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                .map(function(n) { return {v: n, t: n} });

            var fontSizes = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                24, 28, 32, 36, 40, 44, 48, 54, 60, 66, 72, 80, 88, 96, 100]
                .map(function(n) { return {v: n + 'px', t: n} });

            // Number ranges
            HTMLHelpers.bindSelect($('#chartstyle_chart_borderWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_chart_borderRadius'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_series_borderWidth'), numbers.slice(0,6), 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_series_lineWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_chart_plotBorderWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_gridLineWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_yAxis_gridLineWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_pane_background_borderWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_lineWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_lineWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_labels_staggerLines'), numbers.slice(1,6), 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_labels_step'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_yAxis_lineWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_legend_borderWidth'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_legend_borderRadius'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_legend_itemMarginTop'), numbers, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_legend_itemMarginBottom'), numbers, 'v', 't', false, true);

            // Font Sizes
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_labels_style_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_yAxis_labels_style_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_legend_itemStyle_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_series_dataLabels_style_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_xAxis_title_style_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_yAxis_title_style_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_title_style_fontSize'), fontSizes, 'v', 't', false, true);
            HTMLHelpers.bindSelect($('#chartstyle_warning_style_fontSize'), fontSizes, 'v', 't', false, true);

            $('#chartstyle_xAxis_labels_style_fontSize').val('10px');
            $('#chartstyle_yAxis_labels_style_fontSize').val('10px');
            $('#chartstyle_legend_itemStyle_fontSize').val('10px');
            $('#chartstyle_series_dataLabels_style_fontSize').val('10px');
            $('#chartstyle_xAxis_title_style_fontSize').val('9px');
            $('#chartstyle_yAxis_title_style_fontSize').val('9px');
            $('#chartstyle_title_style_fontSize').val('9px');
            $('#chartstyle_warning_style_fontSize').val('9px');
        },
        hideFormatRulesBtn: function () {
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var isMainDataGroup = dataGroup.isMain;
            var usesMainRules = $("#chkUseMainFormattingRules").attr("checked");

            $("#btnFormattingRules").closest(".settingItem").css("display", isMainDataGroup || !usesMainRules ? "" : "none");
        },
        showHideExportAsImage: function (seriesType, dataGroup, contentType) {
            var st = Storyboard.Constants.SeriesTypes;

            seriesType = seriesType || parseInt($("#ddlSeriesType option:selected").val(), 10);
            dataGroup = dataGroup || ChartSetupDataBinding.GetBoundDataGroup();
            contentType = contentType || ChartSetupDataBinding.GetBoundContentType();

            var isPolar = Storyboard.Constants.SeriesTypes.canBePolar(seriesType) ? $('#chbTransformIntoPolar').attr("checked") : false;

            if (!dataGroup.isMain ||
                contentType == Storyboard.Constants.itemTypes.HEATMAP ||
                seriesType == st.VERTICALLINE || seriesType == st.VERTICALSPLINE || seriesType == st.VERTICALAREA ||
                seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE ||
                seriesType == st.TREEMAP || seriesType == st.HEATMAP || seriesType == st.MARIMEKKO ||
                (isPolar && (seriesType == st.BAR || seriesType == st.COLUMN || seriesType == st.SPLINE))) {
                $('.hdOther .exportAsImage').hide();
            } else {
                $('.hdOther .exportAsImage').show();
            }
        },
        showHideExcludeZeroFromTop: function () {
            var calcType = $("#ddlCalculationType").val() || "";
            if (calcType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT || calcType == Storyboard.Constants.CalculationTypes.CATEGORICAL_COUNT)
                $('.sExcludeZeroFromTopBottom').show();
            else
                $('.sExcludeZeroFromTopBottom').hide();
        },
        bindAutoPreview: function(selector) {
            var updateChartPreview = function() {
                $('#btnUpdateChart').trigger('click');
                $('#divChart').css('display', '').children().remove();
            };

            $(selector).each(function() {
                if ($(this).is('select') || $(this).is('input:checkbox') || $(this).is('input:radio')) {
                    $(this).bind('change.autoPreview', updateChartPreview);
                } else if ($(this).is('input:text')) {
                    if ($(this).hasClass('colorselect-target')) {
                        $(this).bind('categorySelect.DUIColorSelect.autoPreview', updateChartPreview);
                    } else if ($(this).hasClass('colorpicker-target')) {
                        $(this).bind('colorChange.DUIColorPicker.autoPreview', updateChartPreview);
                    } else {
                        $(this).bind('blur.autoPreview', updateChartPreview);
                    }
                }
            });
        },
        unbindAutoPreview: function(selector) {
            $(selector).each(function() {
                if ($(this).is('select') || $(this).is('input:checkbox') || $(this).is('input:radio')) {
                    $(this).unbind('change.autoPreview');
                } else if ($(this).is('input:text')) {
                    if ($(this).hasClass('colorselect-target')) {
                        $(this).unbind('categorySelect.DUIColorSelect.autoPreview');
                    } else if ($(this).hasClass('colorpicker-target')) {
                        $(this).unbind('colorChange.DUIColorPicker.autoPreview');
                    } else {
                        $(this).unbind('blur.autoPreview');
                    }
                }
            });
        },
        limitLoopQnSelections: function () {
            if (!useNewLoopVisualization) return;

            var selectedLoopId = 0;
            $('#questionBox option').removeAttr('disabled');

            // deselect/disable qns from other loops
            if ($('#questionBox option:selected').length > 0) {
                selectedLoopId = $('#questionBox option:selected').first().attr('loopImportId');

                $('#questionBox option[loopImportId!="' + selectedLoopId + '"]').removeAttr('selected');
                $('#questionBox option[loopImportId!="' + selectedLoopId + '"]').attr('disabled', 'disabled');
            }

            // remove filters that do not belong to selected loop
            $('#loopIteratorFilters .settingItemBlock').each(function () {
                var filterBox = $(this);
                var loopImportId = filterBox.attr('loopImportId');

                if (loopImportId != selectedLoopId) {
                    var qnId = filterBox.find('#hidQuestionId').val();
                    var placeholder = $('#filterBox .loopIteratorFilterPlaceholder[value="' + qnId + '"]');
                    placeholder.before(filterBox);
                    placeholder.remove();

                    // deselect options and uncheck Compare
                    HTMLHelpers.setSelectedValues(filterBox.find('select'), '0');
                    filterBox.find('#chkCompare').attr('checked', false).attr('disabled', 'disabled');
                    ChartSetupUI.addFilterToGrouping(filterBox.find('#chkCompare'));
                }
            });

            // add filters that do
            if (selectedLoopId > 0) {
                $('#filterBox .settingItemBlock[isLoopIterator="true"][loopImportId="' + selectedLoopId + '"]').each(function () {
                    var filterBox = $(this);
                    var qnId = $('.hidQuestionId', filterBox).val();
                    if ($('#questionBox option:selected[value="' + qnId + '"]').length === 0) {
                        filterBox.after('<input type="hidden" class="loopIteratorFilterPlaceholder" value="' + qnId + '" />');
                        $('#loopIteratorFilters').append(filterBox);
                    }
                });
            }

            $('#loopIteratorFilters').toggle($('#loopIteratorFilters .settingItemBlock').length > 0);
        },

        initWizard: function (templateId) {
            var $setupChart = $('#setupChart');
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            $(".dataSection").hide();

            // Append controls to Wizard
            $('#wizardChartVariables').append($setupChart.find('#variableSelection .qaSelection .settingsFieldsetContent'));
            $('#wizardChartFilters').append($setupChart.find('#filterBox').parent().removeClass('settingsFieldsetContent'));
            $('#wizardChartHFilters').append($setupChart.find('#hFilterSettingPanel .expandableContent').removeClass("settingsFieldsetContent").addClass('size-1-2'));
            $('#wizardChartTime').append($setupChart.find('#timeSelections .settingsFieldsetContent').removeClass('settingsFieldsetContent'));

            if (contentType === Storyboard.Constants.itemTypes.CHART) {
                $('#wizardChartLayout').css('display', 'block');
                $('#wizardChartLayout .wizardLayoutSettings').append($setupChart.find('#hdSeriesSettings').removeClass('settingsFieldsetContent'));
                $('#wizardChartLayout #hdSeriesSettings').find('.SeriesTypeWrapper').closest('.settingsGroup').css('display', 'none');
                $('#wizardChartLayout #hdSeriesSettings').find('.hdPolarWrapper').closest('.settingsGroup').css('display', 'none');
                $('#wizardChartLayout .hdLegendPos').css('display', 'none');
                $('#wizardChartLayout .wizardLayoutSettings').append($setupChart.find('#divAxisScale'));
                $('#wizardChartLayout .wizardLayoutStyles').prepend($setupChart.find('.hdShowTexts'));
                $('#wizardChartLayout .hdShowTexts').removeClass('settingsFieldsetContent').find('h3').css('display', 'none');
                $('#wizardChartLayout .hdShowTexts > .settingsFieldSetLabel').css('font-weight', 'bold');
                $('#wizardChartLayout .chartLayoutFontSizes > .settingsFieldSetLabel').css('font-weight', 'bold');
                $('#wizardChartLayout #hdSeriesSettings').prepend('<b class="settingsFieldSetLabel wizardLabel">Colors</b>');
                $('#wizardChartLayout .noOfDecimals').prepend('<b class="settingItem settingsFieldSetLabel wizardLabel">Data settings</b>');

                $setupChart.find('#lbl_xAxis_labels_rotation').parent('td').addClass('xAxisTextRotationPlaceholder');
                $('#wizardChartLayout .xAxisTextRotation').append($setupChart.find('#lbl_xAxis_labels_rotation'));
                $('#wizardChartLayout .xAxisTextRotation').append($setupChart.find('#chartstyle_xAxis_labels_rotation'));

                $('#ddlFontSizeDataLabel, #ddlFontSizeLegend, #ddlFontSizeSerieAxis, #ddlFontSizeInformation').html($('#chartstyle_series_dataLabels_style_fontSize').html());

                var axisFontSizeControls = '#chartstyle_xAxis_labels_style_fontSize, #chartstyle_yAxis_labels_style_fontSize';
                var axisFontSize = $(axisFontSizeControls)
                    .map(function() { return $(this).val(); })
                    .toArray()
                    .reduce(function(a, b){
                        return (a === b) ? a : '';
                    });

                var informationFontSizeControls = '#chartstyle_xAxis_title_style_fontSize, #chartstyle_yAxis_title_style_fontSize, #chartstyle_title_style_fontSize, #chartstyle_warning_style_fontSize';
                var informationFontSize = $(informationFontSizeControls)
                    .map(function() { return $(this).val(); })
                    .toArray()
                    .reduce(function(a, b){
                        return (a === b) ? a : '';
                    });

                $('#ddlFontSizeDataLabel')
                    .val($('#chartstyle_series_dataLabels_style_fontSize').val())
                    .bind('change', function() {
                        $('#chartstyle_series_dataLabels_style_fontSize').val($(this).val());
                    });
                $('#ddlFontSizeLegend')
                    .val($('#chartstyle_legend_itemStyle_fontSize').val())
                    .bind('change', function() {
                        $('#chartstyle_legend_itemStyle_fontSize').val($(this).val());
                    });
                $('#ddlFontSizeSerieAxis')
                    .val(axisFontSize)
                    .bind('change', function() {
                        $(axisFontSizeControls).val($(this).val());
                    });
                $('#ddlFontSizeInformation')
                    .val(informationFontSize)
                    .bind('change', function() {
                        $(informationFontSizeControls).val($(this).val());
                    })
                    .closest('td').css('display', function() {
                        if ($('#txtXAxis').val() === '' &&
                            $('#txtYAxis').val() === '' &&
                            !$('#chbShowFilterInTitle').is(':checked')) {
                            return 'none';
                        } else {
                            return '';
                        }
                    });

                ChartSetupUI.unbindAutoPreview(autoPreviewControls.join(','));
                ChartSetupUI.bindAutoPreview(autoPreviewControls.join(','));
            }

            $('#wizardChartPreview').append($setupChart.find('#preview'));

            $('#wizardChartVariables .settingsFieldsetContent > .settingItem').addClass('size-1-2');

            $('#wizardChartHFilters').closest(".settingsFieldset")
                .toggleClass("hidden", ($("#hFilterSettingPanel").css("display") === "none"));

            $('#wizardChartPreviewButton').unbind('click.wizardSetup').bind('click.wizardSetup', function() {
                $setupChart.find('#btnUpdateChart').trigger('click');
                return false;
            });

            // Hide
            $setupChart.find('.dataGroupsSelections').toggleClass('hidden', !($('.dgButton:not(.dgButtonTemplate)').length > 1));
            $setupChart.find('#tabholder, .hdMovAvg, #preview .DUIToolbar').css('display', 'none');
            $('#DUI-ST-MULTIEDIT').css('display', 'none');
            $('#wizardChart').css('display', '').find('.tabs + .expandable > .settingsFieldsetLegend').trigger('click');
            $('#setupHolder').addClass('setupWizard');

            // Template Data
            if (templateId != null) {
                $('.dataSection').show();
                $('#wizardChartVariables').closest('fieldset').removeClass('collapsable').addClass('expandable');
            }
            else {
                $('.dataSection').hide();
                $('#wizardChartVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
            }
        },
        destroyWizard: function() {
            var $setupChart = $('#setupChart');
            var contentType = ChartSetupDataBinding.GetBoundContentType();

            if ($('#setupChart #tabholder .tabs .setupWizardInit').length === 0) {
                $setupChart.find('#tabholder .tabs').prepend('<li class="ui-state-default setupWizardInit"><a>Wizard</a></li>');
                $('#setupChart #tabholder .tabs .setupWizardInit').bind('click', ChartSetupUI.initWizard);
            }

            $('#wizardChartVariables .settingsFieldsetContent > .settingItem').removeClass('size-1-2');

            // Append controls to chart setup
            $setupChart.find('#variableSelection .qaSelection').append($('#wizardChartVariables .settingsFieldsetContent'));
            $setupChart.find('#filterSelection .settingsFieldset:first-child').append($('#wizardChartFilters #filterBox').parent().addClass('settingsFieldsetContent'));
            $setupChart.find('#hFilterSettingPanel').append($('#wizardChartHFilters > div').addClass("settingsFieldsetContent").removeClass('size-1-2'));
            $setupChart.find('#timeSelections').append($('#wizardChartTime > div').addClass('settingsFieldsetContent'));

            if (contentType === Storyboard.Constants.itemTypes.CHART) {
                $('#wizardChartLayout').css('display', 'none');
                $setupChart.find('#hdChartSettings').append($('#wizardChartLayout #hdSeriesSettings').addClass('settingsFieldsetContent'));
                $setupChart.find('#hdSeriesSettings').find('.SeriesTypeWrapper').closest('.settingsGroup').css('display', '');
                $setupChart.find('#hdSeriesSettings').find('.hdPolarWrapper').closest('.settingsGroup').css('display', '');
                $setupChart.find('.hdLegendPos').css('display', '');
                $setupChart.find('.axisScalesWrapper > td:first-child').append($('#wizardChartLayout #divAxisScale'));
                $setupChart.find('#hdAxisSettings').append($('#wizardChartLayout .hdShowTexts').addClass('settingsFieldsetContent').find('h3').css('display', '').end());
                $setupChart.find('.hdShowTexts > .settingsFieldSetLabel').css('font-weight', '');
                $setupChart.find('.chartLayoutFontSizes > .settingsFieldSetLabel').css('font-weight', '');

                $setupChart.find('.xAxisTextRotationPlaceholder').append($('#wizardChartLayout #lbl_xAxis_labels_rotation'));
                $setupChart.find('.xAxisTextRotationPlaceholder').append($('#wizardChartLayout #chartstyle_xAxis_labels_rotation'));
                $setupChart.find('#lbl_xAxis_labels_rotation').parent('td').removeClass('xAxisTextRotationPlaceholder');
                $setupChart.find('.wizardLabel').remove();

                $setupChart.find('#ddlFontSizeDataLabel, #ddlFontSizeLegend, #ddlFontSizeSerieAxis, #ddlFontSizeInformation').unbind('change');

                ChartSetupUI.unbindAutoPreview(autoPreviewControls.join(','));
            }

            $setupChart.find('.preview-groupings').prepend($('#wizardChartPreview #preview'));

            $setupChart.find('.dataGroupsSelections').removeClass('hidden');

            if (contentType == Storyboard.Constants.itemTypes.WORDCLOUD || contentType == Storyboard.Constants.itemTypes.DYNAMICIMAGE ||
                contentType == Storyboard.Constants.itemTypes.HEATMAP || contentType == Storyboard.Constants.itemTypes.ICONSHAPE ||
                contentType == Storyboard.Constants.itemTypes.DYNAMICICONSHAPE || contentType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
                $('#DUI-ST-MULTIEDIT').css('display', 'none');
            }
            else {
                $('#DUI-ST-MULTIEDIT').css('display', '');
            }

            $setupChart.find('#tabholder, #DUI-ST-MULTIEDIT, .hdMovAvg, #preview .DUIToolbar').css('display', '');
            $('#wizardChart').css('display', 'none');
            $('#setupHolder').removeClass('setupWizard');
        },
        removeWizard: function() {
            if ($('#setupHolder').hasClass('setupWizard')) ChartSetupUI.destroyWizard();
            $('#setupChart #tabholder .tabs .setupWizardInit').remove();
        },
        showHideBaseInLoopedQnSettingsBox: function () {
            var calculationType = Number($('#ddlCalculationType option:selected').val());
            var selectedQuestions = $('#questionBox option:selected');
            var anyStackedQuestions = selectedQuestions.filter('[isStacked="true"]').length > 0;
            var allIndexedQuestions = selectedQuestions.length > 0 && selectedQuestions.length == selectedQuestions.filter('[isIndexed="true"]').length;

            var showBaseInLoopedQuestions = anyStackedQuestions && !allIndexedQuestions &&
                (calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT ||
                    calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_COUNT ||
                    calculationType == Storyboard.Constants.CalculationTypes.NUMERIC_AVERAGE);

            $('#baseInLoopedQuestionSettings').toggle(showBaseInLoopedQuestions);
            $('#baseInLoopedQuestionSettings input:checkbox').attr('disabled', !showBaseInLoopedQuestions);

            $('.qaBaseCalculation').toggle($('.qaBaseCalculation .settingsGroup').filter(function(i, el) { return el.style.display !== 'none' }).length > 0);
        },
        showHideRebaseSettingsBox: function () {
            var calculationType = Number($('#ddlCalculationType option:selected').val());
            var selectedQuestions = $('#questionBox option:selected');
            var allIndexedQuestions = selectedQuestions.length > 0 && selectedQuestions.length == selectedQuestions.filter('[isIndexed="true"]').length;

            var showRebaseSettingsBox = !allIndexedQuestions && calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT;

            $('#rebasePercentageShareSettings').toggle(showRebaseSettingsBox);
            $('#rebasePercentageShareSettings input:radio').attr('disabled', !showRebaseSettingsBox);

            $('.qaBaseCalculation').toggle($('.qaBaseCalculation .settingsGroup').filter(function(i, el) { return el.style.display !== 'none' }).length > 0);

            if (!showRebaseSettingsBox) return;

            var showBaseInLoopedQuestions = $('#baseInLoopedQuestionSettings input:checkbox:not(:disabled)').length > 0;
            var useLoopedResponses = $('#chbUseLoopedResponses').is(':checked');

            if (showBaseInLoopedQuestions && useLoopedResponses) {
                $('#rbTotalBase').next('label').text('Total in filter combination within the loop');
                $('#rbFromOtherQuestion').next('label').text('From other question within the loop');
                $('#fromOtherQuestionBox, #rebaseVariableBox').hide();
                $('#rbFromOtherQuestion, #ddlRebaseVariable').attr('disabled', true);
            } else {
                $('#rbTotalBase').next('label').text('Total in project and filter combination');
                $('#rbFromOtherQuestion').next('label').text('From other question');
                $('#fromOtherQuestionBox').show();
                $('#rebaseVariableBox').toggle($('#rbFromOtherQuestion').is(':checked'));
                $('#rbFromOtherQuestion, #ddlRebaseVariable').attr('disabled', false);
            }
        },
        handleBaseSizeAnalysisDropdown: function () {
            if ($('#chkUseWeight').is(':checked')) {
                $('#ddlBaseSizeType').removeAttr('disabled');
            }
			else {
				var analysisType = $('#ddlAnalysisType').val();
                $('#ddlBaseSizeType').val(analysisType == 3 ? "3" : "2");
                $('#ddlBaseSizeType').attr('disabled', 'disabled');
            }
            
            ChartSetupUI.disableWeightVariable({checked:$('#chkUseWeight').is(':checked')});
            
        }
    };
}();

window.lineWidthSelected = function (sender, axis) {
    if ($(sender).val() == 0) {
        var selector = (axis != null) ? '#chartstyle_' + axis + 'Axis_lineColor' : sender.replace('Width','Color');
        $(selector).next()
            .addClass('DUI-ColorPickerOverlayTransparent')
            .attr('title', 'transparent');
    }
};

window.selectDashStyle = function (evt, dashBox) {
    $(dashBox).children('.ChartStyleDashStyleValue').css('background-image', $(evt.currentTarget).children('span').css('background-image'));
    $(dashBox).children('.ChartStyleDashStyleValue').attr('data-value', $(evt.currentTarget).attr('data-value'));
    $(dashBox).trigger('dashStyleSelected', $(evt.currentTarget).attr('data-value'));
    // dropdownlist is after this removed from dom by hideAllMenusAndPanels() in GuiEvents.
};